import { AfterViewInit, Component, Input, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { NgSelectModule } from '@ng-select/ng-select';
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { CountryISO, SearchCountryField } from "ngx-intl-tel-input";
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ToastrService } from "ngx-toastr";
import { Otp, SendCommandDto } from "src/app/model/qModel.model";
// import { Chart, ChartConfiguration, ChartEvent, ChartType } from 'chart.js';
import { ApiService } from "src/app/services/api.service";
import { CommonService } from 'src/app/services/common.service';
import { CommonEnums } from "src/app/utils/enum-utils";
import { switchMap } from "rxjs";
import { Chart } from "chart.js";
import { faL } from "@fortawesome/free-solid-svg-icons";
import { left } from "@popperjs/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { formatDate } from "@angular/common";
declare let $: any

@Component({
  selector: "app-main-content",
  templateUrl: "./main-content.component.html",
})

export class MainContentComponent implements OnInit, AfterViewInit {
  ScoreManagementData: any[] = []
  userId: any;
  isOwnership: boolean = true;
  isSubmitted = false;
  loggedInUser: any;
  addUserErrorMessage: any;
  childData: any
  userResponse: any = [];
  selectedIndex: number = 0;
  getFirstIndexData: any;
  enableGridView: boolean = false;
  isGridView: boolean = true;
  isTreeView: boolean = false;
  s3Url: any;
  noDeviceFount: boolean = false;
  deleteUserResponseMessage: any;
  deleteSuccess: boolean = false;
  isLoading: boolean = false;
  virusReport: any[] = [];
  privacy_score: any;
  security_score: any;
  totalHours: any;
  totalMin: any;
  dataValue: any[] = [];
  totalScreentime: number;
  chartsStrings: any;
  public chart: any = '';
  screenHeight: any = 400;
  lastUpdatedDate: any;
  data: any;
  noOfItemToShowScreen: any;
  X_axis_label: string;
  Y_axix_label: string;
  X_label_parental: string;
  Y_label_parental: string;
  screentimeHorizon: any = "y";
  parentalChartAxis: any = "y";
  youtubeChartAxis: any = "y";
  recommdAxis: string = 'x';
  user: any;
  userdevicecount: any;
  totalExpired: any;
  totalExpiringSoon: any;
  totallicenseFreeCount: any;
  showscreentime: boolean = false;
  showSmartParent: boolean = false;
  showThreat: boolean = false;
  showYoutube: boolean = false;
  @Input() isAnnouncemnt: boolean;
  @Input() isOffer: boolean;
  @Input() isblog: boolean;
  @Input() issurvey: boolean;
  getMyAnnounce: any[];
  getMyOffer: any[];
  getMyBlog: any[];
  getMySurvey: any[];
  gettop3: any[];
  isExpandedsurevy: boolean;
  noOfItemToShowThreat: any;
  threatDeviceCount: any[] = [];
  devicenamelength: any;
  namethreat: any;
  firstname: any;
  secondname: any;
  deviceName: any;
  threatsdetected: any;
  youtubeTableDtoList: any;
  antiTrackerChartAxis: any = "y";
  antiTracker_X_lable: string;
  antiTracker_Y_lable: string;
  antiTrackersBlockedCnt: any = 0;

  //@Input() top3: boolean;
  top3: boolean = false;
  new: any[];
  getAllCampaignsData: any[];
  topcamp: any[];
  ANNOUNCEMENT: any;
  screenToggle: boolean;
  premiumStatus: boolean;
  templateType: any;
  campaignType: any;
  announcement: string;
  blogs: string;
  offers: string;
  survey: string;
  disabled: boolean;
  noOfParentalData: number;
  paretalToggle: boolean;
  totalHitCounts: any;
  horizontalGrid: boolean = false;
  verticalGrid: boolean = true;
  showParentalTab: boolean = true;
  noOfDevices: any = 0;
  deviceNameListMap: Map<any, any>;
  totalTimeSpent: any;
  totalMinSpent: number;
  isYoutubeUsageChart: boolean;
  youtubeToggle: boolean;
  showAntiTrackerReports: boolean = false;
  parentalGraph: boolean = false;
  getNotification: any[];
  AllNotCount: number = 0;
  selectedNotType: String;
  alertNotCount: number = 0;
  infoNotCount: number = 0;
  notification: boolean = false;
  requestTypes: String = '';
  cmdfailedDeviceName: String = '';
  private modalRef: NgbModalRef | null = null;
  isPaymentDone: boolean = false;
  isCarouselVisible = false;
  viewAllNotCount: number = 0;
  viewAlertNotCount: number = 0;
  viewInfoNotCount: number = 0;

  ngAfterViewInit() {
    this.selectedIndex = 0;
    $(document).ready(function () { $('.carousel').carousel({ interval: 1200 }) });
  }

  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  @ViewChild('barChartGraph') barChartGraph: any;
  mobileNumber: string = "";
  emailResponse: string = '';
  sentMobileNo: string = '';
  mobileOTPResponse: string = '';
  durationMinutes: string = '';
  timer: any;
  timeOver: any;
  otpError: any;
  otpValue: string = "";
  otpDto: Otp = new Otp();
  sendCommanddto: SendCommandDto = new SendCommandDto();
  isMobile: boolean = true;
  isOTP: boolean = false;
  isDone: boolean = false;
  deviceId: any = '';
  privacyTotalScore: number = 0;
  privacyScore: number = 0;
  securityTotalScore: number = 0;
  getMyIndexData: any;
  securityScore: number = 0;

  norecordsThreatReportArea: boolean = false;
  public needleValueSecurity: number = 1;
  privacyRecommendations: any[] = [];
  securityRecommendations: any[] = [];
  privacyScoreStatus: any;
  securityScoreStatus: any;
  isMobileVerified: boolean = false;
  productKeyType: string = '';
  screenWidth: any = 400;
  deviceType: string = '';
  security_rot_deg: number = 0;
  privacy_rot_deg: number = 0;
  securityStatusBg: string;
  securityScoreIcon: CommonEnums;
  securityStatusClr: string;
  privacyStatusBg: any;
  privacyStatusClr: any;
  privacyScoreIcon: any;
  selectedReport: any;
  notify: any;
  unreadNotifications: any[];
  isPanelOpen = false;

  customOptions: OwlOptions = {
    autoWidth: true,
    loop: true,
    dots: true,
    nav: false,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    autoplaySpeed: 1200,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    margin: 0,
    stagePadding: 15,
    responsive: {
      0: {
        dotsEach: 5,
        items: 1
      },
      300: {
        dotsEach: 5,
        items: 2
      },
      400: {
        dotsEach: 5,
        items: 2
      },
      600: {
        dotsEach: 3,
        items: 4
      },
      800: {
        items: 4
      },
    },
  }
  blogOptions: OwlOptions = {
    loop: true,
    dots: false,
    nav: false,
    autoplay: false,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    autoplaySpeed: 1200,
    mouseDrag: false,
    autoWidth: true,
    touchDrag: false,
    pullDrag: false,
    margin: 0,
    stagePadding: 15,
    responsive: {
      0: {
        dotsEach: 5,
        items: 1
      },
      600: {
        items: 2
      },
    },
  }
  dashboardMarkup: any[] = [];
  dashboardOptions: OwlOptions = {

    dots: true,
    nav: false,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    autoplaySpeed: 1200,
    mouseDrag: true,
    autoWidth: true,
    touchDrag: false,
    pullDrag: false,
    margin: 10,
    stagePadding: 0,
    responsive: {
      0: {
        dotsEach: 5,
        items: 1
      },
      300: {
        items: 1
      },
    },
  }

  announcementOptions: OwlOptions = {
    dots: false,
    nav: false,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    autoplaySpeed: 1200,
    mouseDrag: false,
    autoWidth: true,
    touchDrag: false,
    pullDrag: false,
    margin: 10,
    stagePadding: 15,
    responsive: {
      0: {
        dotsEach: 5,
        items: 1
      },
      300: {
        items: 1
      },
    },
  }




  announcementArray: any;
  blogStore: any[] = []
  deviceDetailForm: FormGroup = new FormGroup({
    userName: new FormControl(''),
    countryCode: new FormControl('')
  });
  CountryISO = CountryISO;
  SearchCountryField = SearchCountryField;
  margins: any;
  translation$ = this.translateService.onLangChange.pipe(
    switchMap(({ lang }) => this.translateService.getTranslation(lang))
  );
  enDataJson: any
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];


  constructor(private translateService: TranslateService,
    private commonService: CommonService,
    private _service: ApiService,
    private router: Router,
    private _toastr: ToastrService,
    private modalService: NgbModal) {
    this.commonService.privacyscore.subscribe((privacyscore) => {
      this.privacy_score = privacyscore && privacyscore != null ? JSON.parse(privacyscore) : 0;

      let filterDropDown = [];
      translateService.get(["PARENTALREPORTS"]).subscribe(
        values => {
          filterDropDown = Object.keys(values).map(key => values[key]);
          this.chartsStrings = filterDropDown[0];
        }
      );
    })

    this.commonService.securityscore.subscribe((securityscore) => {
      this.security_score = securityscore && securityscore != null ? JSON.parse(securityscore) : 0;
    })
    translateService.addLangs(["en", "fr", "it", "ja"]);
    translateService.setDefaultLang("en");
    translateService.get(['DASHBOARD']).subscribe((values) => {
      this.enDataJson = Object.keys(values).map((key) => values[key]);
    });
  }
  totalexpiringsooncount: any;
  totalexpiredcount: any;
  selectedLanguage: any;
  currentUserData: any;
  devicesList: any[] = []
  color: any;
  securityColor: any;
  securityRangeLeve1: any;
  securityRangeLeve2: any;
  scrollPercentRounded: number;
  getDeviceId: string = ''
  getUserId: string = '';
  delimitervalue: number = 1;
  delimiterPrivacyvalue: number = 1;
  public canvasWidth = 300
  public canvasHeight = 150
  public needleValue = 1;
  public centralLabel = ''
  options = {};
  options1 = {};
  allNotification: any[] = [];
  unreadCount: number = 0;
  img_blr: boolean = false;
  restorePublishForm: FormGroup = new FormGroup({
    mobileDeviceName: new FormControl('')
  })

  statusBg: string = '';
  statusClr: string = '';
  statusprivacyBg: string = '';
  statusPrivacyClr: string = '';
  showUrl: boolean = false;
  userTimezone: string;

  threatTableData(deviceId: any) {
    this.isLoading = true;
    this._service.getService(this._service.API_URL.threatTableReport + deviceId + '?deviceType=' + this.deviceType).subscribe((res: any) => {
      if (res && res.status.code == 200) {
        this.virusReport = res.data;
        this.isLoading = false;
      } else {
        this.isLoading = false;
      }
    })
  }


  ngOnDestroy() {
    document.body.classList.remove('main-content-page');
  }


  ngOnInit() {
    this.userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'; // Fallback to UTC if not available
    this.isPanelOpen = false;
    document.body.classList.add('main-content-page');
    this.isCarouselVisible =
      (this.totalExpired && this.totalExpired > 0) ||
      (this.totalExpiringSoon && this.totalExpiringSoon > 0) ||
      (this.totallicenseFreeCount && this.totallicenseFreeCount > 0);
    this.resetGraphData();
    if (this.router.url == '/home/main-content') {
      this.showUrl = true;

    }
    this.enableGridView = true;
    scrollTo(0, 0)
    let currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      this.currentUserData = JSON.parse(currentUser);
    }

    this.getMyUser();
    this.showscreentime = true;
    this.selectedIndex = 0;
    this.selectedNotType = 'All';
    let selectedLangStringValue = localStorage.getItem('selectedLang');
    if (selectedLangStringValue) {
      this.selectedLanguage = selectedLangStringValue;
      this.translateService.use(this.selectedLanguage)
    }

    this.translateService
      .get([
        'PARENTALREPORTS.CHART.HOURS',
        'PARENTALREPORTS.CHART.DEVICES',
        'PARENTALREPORTS.CHART.NOOFATTEMPTS',
        'PARENTALREPORTS.CHART.TRACKERSBLOCKED',
        'DASHBOARD.ANNOUCEMENT',
        'DASHBOARD.BLOGS',
        'DASHBOARD.OFFERS',
        'DASHBOARD.SURVEY',
        'PARENTALREPORTS.TIMEINMINS',
        'PARENTALREPORTS.ALL'
      ])
      .subscribe(translations => {
        this.X_axis_label = translations['PARENTALREPORTS.CHART.HOURS'];
        this.Y_axix_label = translations['PARENTALREPORTS.CHART.DEVICES'];
        this.X_label_parental = translations['PARENTALREPORTS.CHART.NOOFATTEMPTS'];
        this.Y_label_parental = translations['PARENTALREPORTS.CHART.DEVICES'];
        this.antiTracker_X_lable = translations['PARENTALREPORTS.CHART.TRACKERSBLOCKED'];
        this.antiTracker_Y_lable = translations['PARENTALREPORTS.CHART.DEVICES'];

        this.announcement = translations['DASHBOARD.ANNOUCEMENT'];
        this.blogs = translations['DASHBOARD.BLOGS'];
        this.offers = translations['DASHBOARD.OFFERS'];
        this.survey = translations['DASHBOARD.SURVEY'];

        this.timeInhours = translations['PARENTALREPORTS.TIMEINMINS'];
        this.selectedNotType = translations['PARENTALREPORTS.ALL'];
      });

    this.userId = this.currentUserData.id;
    this.getSystemMobileData();
    this.getScreentimeData(this.currentUserData.id);
    this.getAllUserLicense()
    setTimeout(() => {
      if (this.currentUserData.mobileNo) {
        this.deviceDetailForm.controls['userName'].setValue(this.currentUserData.mobileNo)
        this.areaChart(this.currentUserData.id);
        this.donughtChart(this.deviceId);
        this.threatTableData(this.deviceId);
      }
    }, 1000);
    this.screenWidth = window.screen.width;
    this.screenHeight = window.screen.height;
    this.selectedReport = 'screentime';
    window.addEventListener("scroll", function () {
      let reveals = $(".reveal");
      $(document).ready(function () {
        $(window).scroll((e: any) => {
          let scrollTop = $(window).scrollTop();
          let docHeight = $(document).height();
          let winHeight = $(window).height();
          let scrollPercent = (scrollTop) / (docHeight - winHeight);
          const scrollPercentRounded = Math.round(scrollPercent * 100);
          for (let i = 0; i < reveals?.length; i++) {
            if (scrollPercentRounded > 20) {
              reveals[i].classList.add("actively");
            } else {
              reveals[i].classList.remove("actively");
            }
          }
        });
      });
    });
    this.getNotifications(this.userId);
  }

  groupedNotifications: {
    deviceName: string;
    date: String;
    time: String;
    deviceType: string;
    notifications: any[];
    category: String;
    settingType: String;
  }[] = [];

  getNotifications(userId: any) {
    try {
      this.isLoading = true;
      this._service.getService(this._service.API_URL.getNotifications + userId + '?timezone=' + this.userTimezone + '&selectedLang=' + this.selectedLanguage).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.getNotification = response?.data?.mobileNotificationData;
          this.selectedNotType = 'All';
          this.AllNotCount = this.getNotification.length;
          this.alertNotCount = this.getNotification.filter(noti => noti.notificationCat === 'ALERT').length;
          this.infoNotCount = this.getNotification.filter(noti => noti.notificationCat === 'INFO').length;
          this.viewAllNotCount = response.data?.counts?.allCount;
          this.viewAlertNotCount = response.data?.counts?.alertCount;
          this.viewInfoNotCount = response.data?.counts?.infoCount;
          this.unreadNotifications = this.getNotification.filter(n => !n.viewTime);
          if (this.devicesList?.length > 0) {
            this.unreadCount = response.data?.counts?.unReadCount;
          }

          this.allNotification = this.getNotification;
          this.groupNotifications(this.getNotification);
        } else {
          this.isLoading = false;
        }
      });
    } catch (error) {
      this.isLoading = false;
    }
  }

  groupNotifications(data: any) {
    this.groupedNotifications = [];
    for (let notification of data) {
      const today: string = new Date().toISOString().split('T')[0];
      const today1 = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(today1.getDate() - 1);
      const formattedDate = yesterday.toISOString().split('T')[0];
      if (notification.time === today) {
        notification.time = this.translateService.instant('DASHBOARD.TODAY');
        notification.notTime = this.getTimeDifferenceFromNow(notification.notTime);
      }
      if (notification.time === formattedDate) {
        notification.time = this.translateService.instant('DASHBOARD.YESTERDAY');
      }

      let existingDevice = this.groupedNotifications.find(
        group => group.date === notification.time
      );
      if (existingDevice) {
        existingDevice.notifications.push(notification);
      } else {

        this.groupedNotifications.push({
          deviceName: notification.deviceName,
          date: notification.time,
          time: notification.notTime,
          deviceType: notification.deviceType,
          notifications: [notification],
          category: notification.notificationCat,
          settingType: notification.settingType
        });
      }
    }
  }


  filterNotification(cat: String) {
    if (cat === 'ALERT') {
      this.groupNotifications(this.allNotification.filter(noti => noti.notificationCat === 'ALERT'));
    }
    else if (cat === 'INFO') {
      this.groupNotifications(this.allNotification.filter(noti => noti.notificationCat === 'INFO'));
    }
    else {
      this.groupNotifications(this.allNotification);
    }
  }
  markAsRead(notification: any) {
    try {
      if (notification?.notificationId !== undefined && notification.notificationId !== null) {
        const notificationdto = { notificationId: notification.notificationId, deviceType: notification.deviceType };
        this._service.postService(this._service.API_URL.saveNotificationTime, notificationdto).subscribe((response) => {
          if (response && response.status.code === 200) {
            notification.viewTime = new Date();
            this.unreadCount--;
          } else {
            this._toastr.error('', response.status.message)
          }
        })
      }
    }

    catch (error) {
      console.error('Error marking notification as read:', error);
    }
  }


  notificationConfig: { [key: string]: (notify: any) => string } = {
    SMART_PARENTING_WEB: notify =>
      this.translateService.instant('NOTIFICATION.SMART_PARENTING_WEB', { category: notify.category }),
    WEB_SECURITY: notify =>
      this.translateService.instant('NOTIFICATION.WEB_SECURITY', { category: notify.category }),
    SMART_PARENTING_APP: notify =>
      this.translateService.instant('NOTIFICATION.SMART_PARENTING_APP', { appName: notify.appName }),
    INTUDER: notify =>
      this.translateService.instant('NOTIFICATION.INTUDER', { intruderEmailId: notify.intruderEmailId }),
    THREAT: notify => {
      const appList = notify.appName?.split(',').join(', ');
      return this.translateService.instant('NOTIFICATION.THREAT', { appName: appList });
    },
    SETTING_FAILURE: notify => {
      const types = notify.settingType?.split(',') || [];
      const translatedTypes = types.map((type: string) =>
        this.translateService.instant('DASHBOARD.' + type.trim())
      );
      const joinedTypes = translatedTypes.join(', ');
      return this.translateService.instant('NOTIFICATION.SETTING_FAILURE', {
        settingType: joinedTypes
      });
    },

    EXPIRY: (notify) => {
      if (notify.expiryStatus === 'LICENSE_EXPIRING_SOON') {
        const today = new Date();
        const expiryDate = new Date(today);
        expiryDate.setDate(today.getDate() + notify.expiryInDays + 1);
        const formattedDate = formatDate(expiryDate, 'MMM dd yyyy', 'en-US');

        return this.translateService.instant('NOTIFICATION.EXPIRY_SOON', { date: formattedDate });
      }
      if (notify.expiryStatus === 'LICENSE_EXPIRED') {
        return this.translateService.instant('NOTIFICATION.EXPIRED');
      }
    },

    PARENTAL_CONTROL_WEBSITE: notify =>
      this.translateService.instant('NOTIFICATION.PARENTAL_CONTROL_WEBSITE', { website: notify.website }),
    BLOCK_HACKING_ATTEMPT: notify =>
      this.translateService.instant('NOTIFICATION.BLOCK_HACKING_ATTEMPT', { action: notify.action }),
    RANSOMWARE_ALERT: notify =>
      this.translateService.instant('NOTIFICATION.RANSOMWARE_ALERT', { file_name: notify.file_name }),
    PUA_APPLICATION_BLOCKED: notify =>
      this.translateService.instant('NOTIFICATION.PUA_APPLICATION_BLOCKED', { adware: notify.adware }),
    VIRUS_REPAIRED: () =>
      this.translateService.instant('NOTIFICATION.VIRUS_REPAIRED'),
    VIRUS_ACCESS_DENIED: notify =>
      this.translateService.instant('NOTIFICATION.VIRUS_ACCESS_DENIED', { virus_detected: notify.virus_detected }),
    DATA_BACKUP_INSUFFICIENT_SPACE: () =>
      this.translateService.instant('NOTIFICATION.DATA_BACKUP_INSUFFICIENT_SPACE'),
    INTRUSION_DETECTION_SYSTEM: () =>
      this.translateService.instant('NOTIFICATION.INTRUSION_DETECTION_SYSTEM'),
    BROWSING_PROTECTION: notify =>
      this.translateService.instant('NOTIFICATION.BROWSING_PROTECTION', { website: notify.website }),
    FIREWALL_WARNING: notify =>
      this.translateService.instant('NOTIFICATION.FIREWALL_WARNING', { program_name: notify.program_name }),
    PHISHING_PROTECTION: notify =>
      this.translateService.instant('NOTIFICATION.PHISHING_PROTECTION', { website: notify.website }),
    PARENTAL_CONTROL_APPLICATION: notify =>
      this.translateService.instant('NOTIFICATION.PARENTAL_CONTROL_APPLICATION', { website: notify.application }),
    VIRUS_DELETED: () =>
      this.translateService.instant('NOTIFICATION.VIRUS_DELETED'),
    EXPIRY_NOTIFICATION: (notify) => {
      if (notify.expiryStatus === 'LICENSE_EXPIRING_SOON') {
        const today = new Date();
        const expiryDate = new Date(today);
        expiryDate.setDate(today.getDate() + notify.expiryInDays + 1);
        const formattedDate = formatDate(expiryDate, 'MMM dd yyyy', 'en-US');

        return this.translateService.instant('NOTIFICATION.EXPIRY_SOON', { date: formattedDate });
      }
      if (notify.expiryStatus === 'LICENSE_EXPIRED') {
        return this.translateService.instant('NOTIFICATION.EXPIRED');
      }
    },
  };


  getTimeDifferenceFromNow(timeStr: string): string {
    const now = new Date();
    const [hours, minutes] = timeStr.split(':').map(Number);
    const givenTime = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      hours,
      minutes,
      0
    );
    const diffMs = now.getTime() - givenTime.getTime();
    const diffAbs = Math.abs(diffMs);
    const diffMinutes = Math.floor(diffAbs / (1000 * 60));
    const diffHours = Math.floor(diffMinutes / 60);
    const remainingMinutes = diffMinutes % 60;

    if (diffHours > 0) {
      return `${diffHours} hr${diffHours > 1 ? 's' : ''} ${remainingMinutes} min${remainingMinutes !== 1 ? 's' : ''}`;
    } else {
      return `${remainingMinutes} min${diffMinutes !== 1 ? 's' : ''}`;
    }
  }

  openSendControlPopup(id: any, type: any, productType: any, deviceName: any) {
    this.sendCommanddto.deviceId = id;
    this.sendCommanddto.productKeyType = productType;
    this.cmdfailedDeviceName = deviceName;
    const items = type
      .split(',')
      .map((item: any) => item.trim())
      .filter((item: any) => item !== '');
    const uniqueItems = Array.from(new Set(items));
    this.requestTypes = uniqueItems.join(', ');
    this.sendCommanddto.settingFailureTypes = uniqueItems.join(', ');
    $("#controlRequestPopup").modal("show");
  }

  hideSendControlPopup() {
    $("#controlRequestPopup").modal("hide");
  }

  translateRequestTypes(type: any) {
    return this.enDataJson[0][type];
  }

  sendCommands() {
    try {
      this._service.postService(this._service.API_URL.resendFailedCommand, this.sendCommanddto).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this._toastr.success('', response.status.message);
          this.hideSendControlPopup();
        } else {
          this.isLoading = false;
          this._toastr.error('', response.status.message);
        }
      })
    } catch (error) {
      this.isLoading = false;
    }
  }

  camelCaseToTitle(camelCase: string): string {
    if (!camelCase) return '';
    return camelCase
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase())
      .trim();
  }

  getNotificationMessage(notify: any): string {

    const autoFeatureOnLabels: Record<string, string> = {
      FIFTEEN_MINUTES: this.translateService.instant('NOTIFICATION.AUTO_FEATURE_LABELS.FIFTEEN_MINUTES'),
      THIRTY_MINUTES: this.translateService.instant('NOTIFICATION.AUTO_FEATURE_LABELS.THIRTY_MINUTES'),
      ONE_HOUR: this.translateService.instant('NOTIFICATION.AUTO_FEATURE_LABELS.ONE_HOUR'),
      AFTER_REBOOT: this.translateService.instant('NOTIFICATION.AUTO_FEATURE_LABELS.AFTER_REBOOT')
    };

    const uniqueSettingType = Array.from(
      new Set((notify.settingType ?? "").split(',').map((s: string) => s.trim()))
    ).join(', ');
    notify.settingType = uniqueSettingType;
    const type = notify.notificationType || notify.systemNotificationType;
    const notificationstypes = this.notificationConfig[type];
    if (notificationstypes) return notificationstypes(notify);

    if (!isNaN(Number(type)) && notify.featureName) {
      const readableName = this.translateService.instant(notify.featureName);
      const status = notify.value === 1 ? 'NOTIFICATION.ON' : 'NOTIFICATION.OFF';
      let msg = this.translateService.instant('NOTIFICATION.FEATURE_STATUS_CHANGED', {
        feature: readableName,
        status: this.translateService.instant(status)
      });
      if (notify.value === 0 && notify.autoFeatureOn && notify.autoFeatureOn && notify.autoFeatureOn != 'TURN_ON') {
        const timeText = autoFeatureOnLabels[notify.autoFeatureOn];
        if (timeText) {
          const key = notify.autoFeatureOn === 'AFTER_REBOOT' ? 'NOTIFICATION.AUTO_FEATURE_ON_AFTER_REBOOT' : 'NOTIFICATION.AUTO_FEATURE_ON';
          msg += ' ' + this.translateService.instant(key, { minutes: timeText });
        }

      }
      return msg;
    }

    return this.translateService.instant('NOTIFICATION.UNKNOWN_TYPE');
  }

  isShortMessagePanel(): boolean {
    if (this.viewAllNotCount) {
      const msg = this.getNotificationMessage(this.groupedNotifications[0]) ?? '';
      return msg.length <= 68;
    }
    return false;
  }


  NotificationsPopup() {
    this.getNotifications(this.userId);
    this.notification = true;
    this.isPanelOpen = true;
  }
  closeModal4() {
    this.notification = false;
    this.isPanelOpen = false;
  }

  //Screentime Charts

  setAxisForGraph(count: any) {
    if (count > 3) {
      this.screentimeHorizon = "x";
      this.recommdAxis = "y";
      this.horizontalGrid = true;
      this.verticalGrid = false;
      this.X_axis_label = this.translateService.instant('PARENTALREPORTS.CHART.DEVICES');
      this.Y_axix_label = this.translateService.instant('PARENTALREPORTS.CHART.HOURS');
    }
    else {
      this.screentimeHorizon = "y";
      this.recommdAxis = "x";
      this.horizontalGrid = false;
      this.verticalGrid = true;
      this.X_axis_label = this.translateService.instant('PARENTALREPORTS.CHART.HOURS');
      this.Y_axix_label = this.translateService.instant('PARENTALREPORTS.CHART.DEVICES');
    }
  }
  setAxisForAntiTrackerGraph(count: any) {
    if (count > 3) {
      this.antiTrackerChartAxis = "x";
      this.horizontalGrid = true;
      this.verticalGrid = false;
      this.antiTracker_X_lable = this.translateService.instant('PARENTALREPORTS.CHART.DEVICES');
      this.antiTracker_Y_lable = this.translateService.instant('PARENTALREPORTS.CHART.TRACKERSBLOCKED');
    }
    else {
      this.antiTrackerChartAxis = "y";
      this.horizontalGrid = false;
      this.verticalGrid = true;
      this.antiTracker_X_lable = this.translateService.instant('PARENTALREPORTS.CHART.TRACKERSBLOCKED');
      this.antiTracker_Y_lable = this.translateService.instant('PARENTALREPORTS.CHART.DEVICES');
    }
  }
  calculteTotalScreentime(data: any) {
    return data.reduce((acc: any, curr: any) => acc + curr, 0);
  }
  resetGraphData() {
    Chart.getChart("deviceWiseScreentime")?.destroy(); // <canvas> id
    Chart.getChart("threatReportChart")?.destroy(); // <canvas> id
    Chart.getChart("deviceWiseParental")?.destroy();
    Chart.getChart("youtubeUsageGraph")?.destroy();

    this.chart = {};
  }

  getScreentimeSettings(userId: any) {
    this._service.getService(this._service.API_URL.getScreentimeSettings + userId).subscribe((response: any) => {
      if (response && response.data && response.status.code === 200) {
        let settings = response['data']?.map((res: any) => res.isEnabled);
        let premiumDeviceData = response['data']?.map((res: any) => res.isPremiumDevice);
        let enabledSetting = settings.filter((setting: boolean) => setting === true);
        if (settings.length != 0) {
          this.screenToggle = enabledSetting?.length < 1 ? false : true;
        }
        else {
          this.screenToggle = true;
        }
      }
    }
    )
  }

  textArray: any[] = []
  getScreentimeData(userId: any) {
    this.textArray = [{
      text: this.translateService.instant('PARENTALREPORTS.UTILIZATION.LIMIT'),
      color: '#FFBFBF',
    },
    {
      text: this.translateService.instant('PARENTALREPORTS.UTILIZATION.UNDER'),
      color: '#D0E2EA',
    },
    {
      text: this.translateService.instant('PARENTALREPORTS.UTILIZATION.OVER'),
      color: '#DC392F',
    }
    ]
    this.isLoading = true;
    this.getScreentimeSettings(userId);
    this._service.getService(this._service.API_URL.getUserWiseScreentime + userId + "?width=" + this.screenWidth + "&height=" + this.screenHeight).subscribe((response) => {
      if (response && response.data && response.status.code === 200) {
        this.data = response.data;
        this.isLoading = false;
        this.noOfItemToShowScreen = response.data.filter((temp: any) => temp.settingStatus === "Report Device").length;
        this.setAxisForGraph(response.data.length);
        if (response.data.graphList?.length != 0) {
          setTimeout(() => {
            let chartExist = Chart.getChart("deviceWiseScreentime"); // <canvas> id
            if (chartExist != undefined) {
              chartExist.destroy();
            }
            let datalabels = response['data']?.map((res: any) => res.deviceName);
            let dataValue = response['data']?.map((res: any) => res.settingStatus === "Report Device" ? res.usedTime : 0);
            let dataUnderTime = response['data']?.map((res: any) => res.underTime);
            let dataOverTime = response['data']?.map((res: any) => res.overTime);
            let settingStatusData = response['data']?.map((res: any) => res.settingStatus);
            let overBarColors = response['data']?.map((res: any) => res.settingStatus === "Report Device" ? '#FF3C33' : '#C4C4C4');
            let datalabelUsed: any = this.textArray[1].text;
            let datalabelOver: any = this.textArray[2].text;
            this.totalScreentime = this.calculteTotalScreentime(dataValue);
            this.totalHours = Math.floor(this.totalScreentime);
            this.totalMin = Math.floor((this.totalScreentime - Math.trunc(this.totalScreentime)) * 60);
            let tick1 = {
              autoSkip: false,
              maxRotation: 0,
              minRotation: 0,
              callback: function (val: any, index: string | number,) {
                return datalabels[index].length > 7 ? datalabels[index].slice(0, 7) + "..." : datalabels[index];
              },
            }
            let tick2 = {
              autoSkip: false,
              maxRotation: 0,
              minRotation: 0,
              callback: function (value: any) {
                return `${value}h`;
              }
            }
            let tickx;
            let ticky;
            if (response.data?.length > 3) {
              tickx = tick1;
              ticky = tick2;
            }
            else {
              tickx = tick2;
              ticky = tick1;
            }
            const canvas = document.getElementById('deviceWiseScreentime');
            const ctx = (canvas as HTMLCanvasElement)?.getContext('2d');
            const gradient = ctx?.createLinearGradient(0, 0, 0, 600);
            gradient?.addColorStop(0, '#E48701');
            gradient?.addColorStop(0.5, '#E48701');
            const gradient2 = ctx?.createLinearGradient(0, 0, 0, 600);
            gradient2?.addColorStop(0, "#006EE5");
            gradient2?.addColorStop(1, "#006EE5");
            const translate = this.translateService;
            this.chart = new Chart("deviceWiseScreentime", {
              type: "bar",
              data: {
                labels: datalabels,
                datasets: [
                  {
                    data: dataUnderTime,
                    label: datalabelUsed,
                    maxBarThickness: window.screen.width > 768 ? 60 : 40,
                    borderColor: '#FFBFBF',
                    borderRadius: 10,
                    barPercentage: 0.8,
                    categoryPercentage: 0.4,
                    hoverBackgroundColor: '#FFBFBF',
                    backgroundColor: '#FFBFBF',
                    hoverBorderColor: '#FFBFBF',
                    borderWidth: 0,
                    barThickness: 10,
                  },
                  {
                    data: dataOverTime,
                    label: datalabelOver,
                    maxBarThickness: window.screen.width > 768 ? 60 : 40,
                    borderColor: overBarColors,
                    borderRadius: {
                      topLeft: 10,
                      bottomRight: 10,
                      topRight: 10,
                    },
                    barPercentage: 0.8,
                    categoryPercentage: 0.4,
                    hoverBackgroundColor: overBarColors,
                    backgroundColor: overBarColors,
                    hoverBorderColor: overBarColors,
                    borderWidth: 0,
                    barThickness: 10,
                  }
                ],
              },
              options: {
                maintainAspectRatio: false,
                indexAxis: this.screentimeHorizon,
                plugins: {
                  annotation: {
                    annotations: {
                      line1: {
                        type: 'line',
                        borderColor: '#AAA4A4',
                        borderWidth: 1,
                        scaleID: this.recommdAxis,
                        value: 4,
                        borderDash: [5, 5],
                        label: {
                          content: 'Value = 4',
                          position: 'center',
                          backgroundColor: '#AAA4A4'
                        }
                      }
                    }
                  },
                  legend: {
                    display: false,
                    position: "top",
                    align: "end",
                  },
                  tooltip: {
                    displayColors: false,
                    backgroundColor: '#023047',
                    bodyColor: '#FFFFFF',
                    titleColor: '#FFFFFF',
                    borderColor: '#023047',
                    borderWidth: 1,
                    padding: {
                      right: 15,
                      left: 15,
                      top: 10,
                      bottom: 10
                    },
                    callbacks: {
                      label(tooltipItem) {
                        let lbl;
                        if (settingStatusData[tooltipItem.dataIndex] === "Toggle Off") {
                          lbl = translate.instant('PARENTALREPORTS.TOOLTIPS.ENABLE_SCREENTIME')
                        }
                        else if (settingStatusData[tooltipItem.dataIndex] === "Empty Report") {
                          lbl = translate.instant('PARENTALREPORTS.TOOLTIPS.EMPTY_REPORT');
                        }
                        else {
                          let hours = Math.floor(parseFloat(tooltipItem.formattedValue));
                          let mins = Math.round((parseFloat(tooltipItem.formattedValue) - Math.trunc(parseFloat(tooltipItem.formattedValue))) * 60);
                          lbl = tooltipItem.dataset.label + " " + hours + "h " + mins + "m";
                        }
                        return lbl;
                      }
                    }
                  },
                  datalabels: {
                    anchor: 'end',
                    align: 'end',
                    display: false
                  }
                },
                responsive: true,
                scales: {
                  x: {
                    stacked: true,
                    grid: {
                      display: this.verticalGrid,
                      color: '#F1F1F1',
                      borderDash: [0, 0],
                      drawTicks: false,
                    },
                    title: {
                      display: true,
                      text: this.X_axis_label,
                      font: {
                        family: 'open sans',
                        size: 14,
                      }
                    },
                    ticks: tickx,
                  },
                  y: {
                    stacked: true,
                    grid: {
                      display: this.horizontalGrid,
                      color: '#F1F1F1',
                      borderDash: [0, 0],
                      drawTicks: false,
                    },
                    title: {
                      display: true,
                      text: this.Y_axix_label,
                      font: {
                        family: 'open sans',
                        size: 14,
                      }
                    },
                    ticks: ticky,
                  },
                },
              },
            });
          }, 500);
        }
      }
    })

  }

  getYoutubeSettings(userId: any) {
    this._service.getService(this._service.API_URL.youtubeSettings + userId).subscribe((response) => {
      if (response && response.status.code === 200) {
        let settings = response['data']?.map((res: any) => res.isEnable);
        let enabledSetting = settings.filter((setting: boolean) => setting === true);
        this.youtubeToggle = enabledSetting?.length < 1 ? true : false;
      }
    })
  }

  youtubeUsageChartData(userId: any) {
    this.isLoading = true;
    this.getYoutubeSettings(this.userId);
    this._service.getService(this._service.API_URL.youtubeUsageReport + userId).subscribe((response) => {
      if (response && response.status.code === 200) {
        this.isLoading = false;
        if (response.data.filter((data: any) => data.premiumStatus === "Premium Version" || data.premiumStatus === "LICENSE_EXPIRED").length != 0) {
          this.isYoutubeUsageChart = true;
          setTimeout(() => {
            let chartExist = Chart.getChart("youtubeUsageGraph"); // <canvas> id
            if (chartExist != undefined) {
              chartExist.destroy();
            }
            let datalabels = response['data']?.map((res: any) => res.key);
            let dataValue = response['data']?.map((res: any) => res.count);
            let totalTime = response.data.filter((data: any) => data.premiumStatus === "Premium Version")?.map((res: any) => res.count).reduce((acc: any, curr: any) => acc + curr, 0);
            this.totalTimeSpent = totalTime;
            this.isLoading = false;
            const BackgroundColors = response.data.map((value: any, index: number) => {
              if (response.data[index].premiumStatus != "Premium Version") return '#C4C4C4';
              if (response.data[index].premiumStatus === "Premium Version") return '#FF3C33';
              return '#FF3C33';
            });
            let tick1 = {
              autoSkip: false,
              maxRotation: 0,
              minRotation: 0,
              callback: function (value: any, index: string | number,) {
                return datalabels[index].length > 7 ? datalabels[index].slice(0, 7) + "..." : datalabels[index];
              },
            }
            let tick2 = {
              autoSkip: false,
              maxRotation: 0,
              minRotation: 0,
              precision: 0,
              callback: function (value: any) {
                return `${value}`;
              }
            }
            let tickx;
            let ticky;
            if (response.data.length > 3) {
              tickx = tick1;
              ticky = tick2;
              this.youtubeChartAxis = "x";
              this.verticalGrid = false;
              this.horizontalGrid = true;
            }
            else {
              tickx = tick2;
              ticky = tick1;
              this.youtubeChartAxis = "y";
              this.verticalGrid = true;
              this.horizontalGrid = false;
            }
            this.chart = new Chart("youtubeUsageGraph", {
              type: "bar",
              data: {
                labels: datalabels,
                datasets: [
                  {
                    data: dataValue,
                    label: this.translateService.instant('PARENTALREPORTS.CHART.ATTEMPTS'),
                    borderColor: BackgroundColors,
                    hoverBackgroundColor: BackgroundColors,
                    hoverBorderColor: BackgroundColors,
                    backgroundColor: BackgroundColors,
                    borderWidth: 0,
                    borderRadius: {
                      topLeft: 10,
                      bottomRight: 10,
                      topRight: 10,
                    },
                    barThickness: 10,
                  },
                ],
              },
              options: {
                maintainAspectRatio: false,
                indexAxis: this.youtubeChartAxis,
                plugins: {
                  legend: {
                    display: false,
                    position: "top",
                    align: "end",
                  },
                  tooltip: {
                    displayColors: false,
                    backgroundColor: '#023047',
                    bodyColor: '#FFFFFF',
                    titleColor: '#FFFFFF',
                    borderColor: '#023047',
                    borderWidth: 1,
                    padding: {
                      right: 15,
                      left: 15,
                      top: 10,
                      bottom: 10
                    },
                    callbacks: {
                      label: (tooltipItem) => {
                        let lbl = tooltipItem.dataset.label + " : " + tooltipItem.dataset.data[tooltipItem.dataIndex];
                        if (response.data[tooltipItem.dataIndex].premiumStatus === "LICENSE_EXPIRED") {
                          lbl = this.translateService.instant('PARENTALREPORTS.TOOLTIPS.LICENSE_EXPIRED');
                        }
                        else if (response.data[tooltipItem.dataIndex].premiumStatus === "Free version") {
                          lbl = this.translateService.instant('PARENTALREPORTS.TOOLTIPS.FREE_VERSION');
                        }
                        else if (response.data[tooltipItem.dataIndex].premiumStatus === "Toggle Off") {
                          lbl = this.translateService.instant('PARENTALREPORTS.TOOLTIPS.TOGGLE_OFF');
                        }
                        else if (response.data[tooltipItem.dataIndex].premiumStatus === "Empty Report") {
                          lbl = this.translateService.instant('PARENTALREPORTS.TOOLTIPS.EMPTY_REPORT');
                        }
                        return lbl;
                      }
                    },
                  },
                  datalabels: {
                    anchor: 'end',
                    align: 'end',
                    display: false
                  }
                },
                responsive: true,
                scales: {
                  x: {
                    stacked: true,
                    grid: {
                      display: this.verticalGrid,
                      color: '#F1F1F1',
                      borderDash: [0, 0],
                      drawTicks: false,
                    },
                    title: {
                      display: true,
                      text: this.translateService.instant('PARENTALREPORTS.CHART.ATTEMPTS'),
                      font: {
                        family: 'open sans',
                        size: 14,
                      }
                    },
                    ticks: tickx,
                  },
                  y: {
                    stacked: true,
                    grid: {
                      display: this.horizontalGrid,
                      color: '#F1F1F1',
                      borderDash: [0, 0],
                      drawTicks: false,
                    },
                    title: {
                      display: true,
                      text: this.Y_axix_label,
                      font: {
                        family: 'open sans',
                        size: 14,
                      }
                    },
                    ticks: ticky,
                  },
                },
              },
            })
          }, 200);
        }
        else {
          this.isYoutubeUsageChart = false;
        }
      }
    });
  }

  getSmartParentalSettings(userId: any) {
    this._service.getService(this._service.API_URL.getParentalSettings + userId).subscribe((response) => {
      if (response && response.status.code === 200) {
        let settings = response['data']?.map((res: any) => res.isEnabled);
        let enabledSetting = settings.filter((setting: boolean) => setting === true);
        this.paretalToggle = enabledSetting?.length < 1 ? false : true;
      }
    })
  }

  getRestrictedHitsPerDevice(userId: any) {
    this.textArray = [{
      text: this.translateService.instant('PARENTALREPORTS.LIMIT_SET'),
      color: '#FFBFBF',
    },
    {
      text: this.translateService.instant('PARENTALREPORTS.WEB'),
      color: '#D0E2EA',
    },
    {
      text: this.translateService.instant('PARENTALREPORTS.APP'),
      color: '#DC392F',
    }
    ]
    this.isLoading = true;
    this.getSmartParentalSettings(userId);
    this._service.getService(this._service.API_URL.getRestictedHitsPerDevice + userId).subscribe((response) => {
      if (response && response.data && response.status.code === 200) {
        this.data = response.data;
        this.isLoading = false;
        this.noOfParentalData = response.data.length;
        if (response.data.graphList?.length != 0) {
          setTimeout(() => {
            let chartExist = Chart.getChart("deviceWiseParental"); // <canvas> id
            if (chartExist != undefined) {
              chartExist.destroy();
            }
            let datalabels = response['data']?.map((res: any) => res.category);
            let dataValue = response['data']?.map((res: any) => res.usedTime);
            let webCountData = response['data']?.map((res: any) => res.webHitCount);
            let appHitData = response['data']?.map((res: any) => res.hitCount);
            let parentalToggle = response.data?.filter((data: any) => data.premiumStatus != "Toggle Off" && data.premiumStatus != "Empty Report");
            this.parentalGraph = parentalToggle?.length < 1 ? true : false;
            let webHitCount = response.data.filter((data: any) => data.premiumStatus === "Premium Version")?.map((res: any) => res.webHitCount).reduce((acc: any, curr: any) => acc + curr, 0);
            let appHitCount = response.data.filter((data: any) => data.premiumStatus === "Premium Version")?.map((res: any) => res.hitCount).reduce((acc: any, curr: any) => acc + curr, 0);
            this.totalHitCounts = webHitCount + appHitCount;
            let datalabelUsed: any = this.textArray[1].text;
            let datalabelOver: any = this.textArray[2].text;
            this.totalScreentime = this.calculteTotalScreentime(dataValue);
            this.totalHours = Math.floor(this.totalScreentime);
            this.totalMin = Math.floor((this.totalScreentime - Math.trunc(this.totalScreentime)) * 60);
            let barwidth = 14;
            let borderwidth = 3;
            if (this.noOfParentalData > 1 && this.noOfParentalData < 4) {
              barwidth = 9;
              borderwidth = 2;
            }
            let tick1 = {
              autoSkip: false,
              maxRotation: 0,
              minRotation: 0,
              callback: function (val: any, index: string | number,) {
                return datalabels[index].length > 7 ? datalabels[index].slice(0, 7) + "..." : datalabels[index];
              },
            }
            let tick2 = {
              autoSkip: false,
              maxRotation: 0,
              minRotation: 0,
              precision: 0,
            }
            let tickx;
            let ticky;
            if (response.data.length > 3) {
              this.parentalChartAxis = "x";
              this.X_label_parental = this.translateService.instant('PARENTALREPORTS.CHART.DEVICES');
              this.Y_label_parental = this.translateService.instant('PARENTALREPORTS.CHART.NOOFATTEMPTS');
              this.horizontalGrid = true;
              this.verticalGrid = false;
              tickx = tick1;
              ticky = tick2;
            } else {
              this.parentalChartAxis = "y";
              this.X_label_parental = this.translateService.instant('PARENTALREPORTS.CHART.NOOFATTEMPTS');
              this.Y_label_parental = this.translateService.instant('PARENTALREPORTS.CHART.DEVICES');
              this.horizontalGrid = false;
              this.verticalGrid = true;
              tickx = tick2;
              ticky = tick1;
            }
            const webBackgroundColors = this.data.map((value: any, index: number) => {
              if (this.data[index].premiumStatus != "Premium Version") return '#C4C4C4';
              if (this.data[index].premiumStatus === "Premium Version") return '#FF3C33';
              return '#FF3C33';
            });
            const appBackgroundColors = this.data.map((value: any, index: number) => {
              if (this.data[index].premiumStatus != "Premium Version") return '#C4C4C4';
              if (this.data[index].premiumStatus === "Premium Version") return '#FAA200';
              return '#FAA200';
            });
            const canvas = document.getElementById('deviceWiseParental');
            const ctx = (canvas as HTMLCanvasElement)?.getContext('2d');
            const gradient = ctx?.createLinearGradient(0, 0, 0, 600);
            gradient?.addColorStop(0, '#E48701');
            gradient?.addColorStop(0.5, '#E48701');
            const gradient2 = ctx?.createLinearGradient(0, 0, 0, 600);
            gradient2?.addColorStop(0, "#006EE5");
            gradient2?.addColorStop(1, "#006EE5");
            this.chart = new Chart("deviceWiseParental", {
              type: "bar",
              data: {
                labels: datalabels,
                datasets: [
                  {
                    data: webCountData,
                    label: datalabelUsed,
                    maxBarThickness: window.screen.width > 768 ? 60 : 40,
                    borderColor: '#FFFFFF',
                    hoverBorderWidth: borderwidth,
                    borderRadius: {
                      topLeft: 10,
                      topRight: 10,
                      bottomRight: 10,
                    },
                    barPercentage: 0.1,
                    categoryPercentage: 0.5,
                    hoverBackgroundColor: webBackgroundColors,
                    backgroundColor: webBackgroundColors,
                    hoverBorderColor: '#FFFFFF',
                    borderWidth: borderwidth,
                    barThickness: barwidth,
                  },
                  {
                    data: appHitData,
                    label: datalabelOver,
                    maxBarThickness: window.screen.width > 768 ? 60 : 40,
                    borderColor: '#FFFFFF',
                    hoverBorderWidth: borderwidth,
                    borderRadius: {
                      topLeft: 10,
                      bottomRight: 10,
                      topRight: 10,
                    },
                    barPercentage: 0.1,
                    categoryPercentage: 0.5,
                    hoverBackgroundColor: appBackgroundColors,
                    backgroundColor: appBackgroundColors,
                    hoverBorderColor: '#FFFFFF',
                    borderWidth: borderwidth,
                    barThickness: barwidth,
                  }
                ],
              },
              options: {
                maintainAspectRatio: false,
                indexAxis: this.parentalChartAxis,
                plugins: {
                  legend: {
                    display: false,
                    position: "top",
                    align: "end",
                  },
                  tooltip: {
                    displayColors: false,
                    backgroundColor: '#023047',
                    bodyColor: '#FFFFFF',
                    titleColor: '#FFFFFF',
                    borderColor: '#023047',
                    borderWidth: 1,
                    padding: {
                      right: 15,
                      left: 15,
                      top: 10,
                      bottom: 10
                    },
                    callbacks: {
                      label: (tooltipItem) => {
                        let lbl = tooltipItem.dataset.label + " : " + tooltipItem.dataset.data[tooltipItem.dataIndex];
                        if (this.data[tooltipItem.dataIndex].premiumStatus === "LICENSE_EXPIRED") {
                          lbl = this.translateService.instant('PARENTALREPORTS.TOOLTIPS.LICENSE_EXPIRED');
                        }
                        else if (this.data[tooltipItem.dataIndex].premiumStatus === "Free version") {
                          lbl = this.translateService.instant('PARENTALREPORTS.TOOLTIPS.FREE_VERSION');
                        }
                        else if (this.data[tooltipItem.dataIndex].premiumStatus === "Toggle Off") {
                          lbl = this.translateService.instant('PARENTALREPORTS.TOOLTIPS.TOGGLE_OFF');
                        }
                        else if (this.data[tooltipItem.dataIndex].premiumStatus === "Empty Report") {
                          lbl = this.translateService.instant('PARENTALREPORTS.TOOLTIPS.EMPTY_REPORT');
                        }
                        return lbl;
                      }
                    }
                  },
                  datalabels: {
                    anchor: 'end',
                    align: 'end',
                    display: false
                  }
                },
                responsive: true,
                scales: {
                  x: {
                    stacked: false,
                    grid: {
                      display: this.verticalGrid,
                      color: '#F1F1F1',
                      borderDash: [0, 0],
                      drawTicks: false,
                    },
                    title: {
                      display: true,
                      text: this.X_label_parental,
                      font: {
                        family: 'Myriad Pro, sans-serif',
                        size: 14,
                      }
                    },
                    ticks: tickx,
                  },
                  y: {
                    stacked: false,
                    grid: {
                      display: this.horizontalGrid,
                      color: '#F1F1F1',
                      borderDash: [0, 0],
                      drawTicks: false,
                    },
                    title: {
                      display: true,
                      text: this.Y_label_parental,
                      font: {
                        family: 'Myriad Pro, sans-serif',
                        size: 14,
                      }
                    },
                    ticks: ticky,
                  },
                },
              },
            });
          }, 500);
        }
      }
    })
  }


  addDevice() {
    this.otpError = null;
    try {
      if (this.currentUserData.mobileVerified) {
        this.router.navigateByUrl('/home/add-device');
      } else {
        this._service.getService(this._service.API_URL.checkVerifiedMobile).subscribe((response) => {
          if (response && response.status.code === 200) {
            if (response.data) {
              this.router.navigateByUrl('/home/add-device');
            } else {
              this.isMobile = true;
              this.isOTP = false;
              this.isDone = false;
              $("#verifyDetailsPopup").modal("show")
            }
          } else {
            this.isLoading = false;
            this._toastr.error('', response.status.message);
          }
        })
      }
    } catch (error) { }
  }

  onMobileDeviceSelect(evt: any) {
    this.deviceId = evt.target.value;
    if (evt.target.value) {
      this.getCampaignData(evt.target.value)
    }
  }


  onUserDeviceSelect(evt: any) {
    this.userId = evt.target.value;
    if (evt.target.value) {
      this.getdashboardDataByuserId(evt.target.value);
      this.getScreentimeData(evt.target.value);
      this.areaChart(evt.target.value);
    }
  }

  getdashboardDataByuserId(userId: any) {
    this.security_rot_deg = 0;
    this.privacy_rot_deg = 0;
    this.userId = userId;
    this.selectedReport = 'screentime';
    this.getScreentimeData(userId);
    this.getDeviceData(userId);
    this.getNotifications(userId);
    this.areaChart(userId);
    this._service.getService(this._service.API_URL.getdashboardDataByuserId + userId).subscribe((response) => {
      localStorage.setItem('selectedUser', this.userId); //to carry forward the user id to next page
      if (response && response.status.code === 200) {
        this.privacyScore = response.data.privacyScore;
        this.privacyTotalScore = response.data.privacyTotalScore;
        this.securityScore = response.data.securityScore;
        this.securityTotalScore = response.data.securityTotalScore;
        this.privacyRecommendations = response.data.privacyRecommendations;
        this.securityRecommendations = response.data.securityRecommendations;
        this.security_rot_deg = (response.data.securityScore * 180) / response.data.securityTotalScore;
        this.privacy_rot_deg = (response.data.privacyScore * 180) / response.data.privacyTotalScore;
        this.delimiterPrivacyvalue = (response.data.privacyScore / 10);
        this.needleValueSecurity = (response.data.securityScore / 10);
        this.securityScoreStatus = response.data.securityScoreStatus;
        this.privacyScoreStatus = response.data.privacyScoreStatus;
        this.productKeyType = response.data.deviceType;
        this.top3 = true;
        this.getCampaignDatalatest(userId);
        if (this.productKeyType == "SYSTEM") {
          this.margins = '12px auto';
        } else {
          this.mblDeviceTypeOnChange();
        }


        if (this.delimiterPrivacyvalue >= 100) {
          this.delimiterPrivacyvalue = 99.9;
        }

        this.privacyScoreStatus = response.data.privacyScoreStatus;
        if (this.privacyScore <= 250) {
          this.privacyStatusBg = "#FDDDDD";
          this.privacyStatusClr = "#DC392F";
          this.privacyScoreIcon = CommonEnums.LOWSCOREICON;
        } else if (this.privacyScore >= 251 && this.privacyScore <= 500) {
          this.privacyStatusBg = "#FFF0F0";
          this.privacyStatusClr = "#FAA200";
          this.privacyScoreIcon = CommonEnums.MEDIUMSCOREICON;
        } else if (this.privacyScore >= 501 && this.privacyScore <= 800) {
          this.privacyStatusBg = "#FDECCE";
          this.privacyStatusClr = "#2144FE";
          this.privacyScoreIcon = CommonEnums.GOODSCOREICON;
        } else {
          this.privacyStatusBg = "#D5FED6";
          this.privacyStatusClr = "#1ECB1A";
          this.privacyScoreIcon = CommonEnums.EXCELLENTSCOREICON;
        }
        if (this.privacyScore >= 50) {
          this.securityColor = 'rgb(58, 215, 55, 1)'
        } else {
          this.securityColor = 'rgb(255, 65, 65, 1)'
        }
        this.options1 = {
          hasNeedle: true,
          needleColor: '#023047',
          needleUpdateSpeed: 1000,
          arcColors: [this.color, 'lightgray'],
          arcDelimiters: [this.delimiterPrivacyvalue ? this.delimiterPrivacyvalue : 1],
          needleStartValue: 0.1,
        }
        if (this.privacyScore <= 250) {
          this.statusprivacyBg = "#FDDDDD";
          this.statusPrivacyClr = "#FF4B2B";
        } else if (this.privacyScore >= 251 && this.privacyScore <= 500) {
          this.statusprivacyBg = "#FFF0F0";
          this.statusPrivacyClr = "#FB6C6C";
        } else if (this.privacyScore >= 501 && this.privacyScore <= 800) {
          this.statusprivacyBg = "#FDECCE";
          this.statusPrivacyClr = "#F59E0B";
        } else {
          this.statusprivacyBg = "#D5FED6";
          this.statusPrivacyClr = "#1ECB1A";
        }
        this.delimitervalue = (response.data.securityScore / 10);
        if (this.delimitervalue >= 100) {
          this.delimitervalue = 99.9;
        }
        this.securityScoreStatus = response.data.securityScoreStatus;
        if (this.securityScore <= 250) {
          this.securityStatusBg = "#FDDDDD";
          this.securityStatusClr = "#DC392F";
          this.securityScoreIcon = CommonEnums.LOWSCOREICON;

        } else if (this.securityScore >= 251 && this.securityScore <= 500) {
          this.securityStatusBg = "#FFF0F0";
          this.securityStatusClr = "#FAA200";
          this.securityScoreIcon = CommonEnums.MEDIUMSCOREICON;
        } else if (this.securityScore >= 501 && this.securityScore <= 800) {
          this.securityStatusBg = "#FDECCE";
          this.securityStatusClr = "#2144FE";
          this.securityScoreIcon = CommonEnums.GOODSCOREICON;
        } else {
          this.securityStatusBg = "#D5FED6";
          this.securityStatusClr = "#1ECB1A";
          this.securityScoreIcon = CommonEnums.EXCELLENTSCOREICON;
        }
        if (this.securityScore >= 50) {
          this.securityColor = 'rgb(58, 215, 55, 1)';
        } else {
          this.securityColor = 'rgb(255, 65, 65, 1)';
        }
        this.options = {
          hasNeedle: true,
          needleColor: '#023047',
          needleUpdateSpeed: 1000,
          arcColors: [this.color, 'lightgray'],
          arcDelimiters: [this.delimitervalue ? this.delimitervalue : 1],
          needleStartValue: 0.1,
        }
        if (this.securityScore <= 250) {
          this.statusBg = "#FDDDDD";
          this.statusClr = "#FF4B2B";
        } else if (this.securityScore >= 251 && this.securityScore <= 500) {
          this.statusBg = "#FFF0F0";
          this.statusClr = "#FB6C6C";
        } else if (this.securityScore >= 501 && this.securityScore <= 800) {
          this.statusBg = "#FDECCE";
          this.statusClr = "#F59E0B";
        } else {
          this.statusBg = "#D5FED6";
          this.statusClr = "#1ECB1A";
        }


      }
    })
  }

  isNavigate(val: string, id: any) {
    if (val == 'VIEW_SCORE' && id === this.userId) {
      this.router.navigate(['home/score-management'])
    }
    if (val == 'VIEW_LICENCE' && id === this.userId) {
      this.router.navigate(['home/license-summary'])
    }
  }

  offerArray: any[] = [];
  surveyArray: any[] = [];
  newcamm: any[] = [];
  offerArraynew: any[] = [];
  surveyArraynew: any[] = [];
  blogStorenew: any[] = []
  announcementnew: any[] = [];


  getCampaignData(deviceId: any) {
    this.isLoading = true;
    try {
      this.offerArray = [];
      this.surveyArray = [];
      this.announcementArray = [];
      this.blogStore = [];
      this._service.getService(this._service.API_URL.getAllcampaignsData + deviceId).subscribe((res: any) => {
        if (res.status.code === 200) {
          this.isLoading = false;
          if (res.data.ANNOUCEMENT || res.data.SURVEY || res.data.BLOG || res.data.OFFER) {
            if (res.data.OFFER) {
              this.offerArray = [...res.data.OFFER];
              this.getMyOffer = res.data.OFFER;
            }
            else if (res.data.SURVEY) {
              this.surveyArray = res.data.SURVEY;
            }
            if (res.data.SURVEY) {
              this.surveyArray = res.data.SURVEY;
              this.getMySurvey = res.data.SURVEY;
            }
            this.blogStore = res.data.BLOG;
            this.getMyBlog = res.data.BLOG;
            this.announcementArray = res.data.ANNOUCEMENT;
            this.getMyAnnounce = res.data.ANNOUCEMENT;
          }
        } else {
          this.isLoading = false;
          this._toastr.error('', res.status.message);
        }
      })
    } catch (error: any) {
      this.isLoading = false;
      this._toastr.error('', error);
    }
  }


  getCampaignDatalatest(deviceId: any) {
    this.isLoading = true;
    try {
      this.offerArray = [];
      this.surveyArray = [];
      this.announcementArray = [];
      this.blogStore = [];
      this._service.getService(this._service.API_URL.getAllcampaignsDataLatest + deviceId).subscribe((res: any) => {
        if (res.status.code === 200) {
          this.isLoading = false;
          if (res.data) {
            this.getAllCampaignsData = [...res.data];
          }
          this.topcamp = res.data;
          this.getAllCampaignsData = this.topcamp;
          this.templateType = res.data.templateType;
          this.issurvey = false;
          this.isAnnouncemnt = false;
          this.isOffer = false;
          this.isblog = false;
        }

        else {
          this.isLoading = false;
          this._toastr.error('', res.status.message);
        }
      })
    } catch (error: any) {
      this.isLoading = false;
      this._toastr.error('', error);
    }
  }

  getDashboardDataById(deviceId: any) {
    this.getDeviceId = deviceId;
    this._service.getService(this._service.API_URL.getDashboardDataById + deviceId).subscribe((response) => {
      if (response && response.status.code === 200) {
        this.privacyScore = response.data.privacyScore;
        this.privacyTotalScore = response.data.privacyTotalScore;
        this.securityScore = response.data.securityScore;
        this.securityTotalScore = response.data.securityTotalScore;
        this.privacyRecommendations = response.data.privacyRecommendations;
        this.securityRecommendations = response.data.securityRecommendations;
        this.delimiterPrivacyvalue = (response.data.privacyScore / 10);
        this.needleValueSecurity = (response.data.securityScore / 10);
        this.securityScoreStatus = response.data.securityScoreStatus;
        this.privacyScoreStatus = response.data.privacyScoreStatus;
        this.productKeyType = response.data.deviceType;


        if (this.productKeyType == "SYSTEM") {
          this.margins = '12px auto';
        } else {
          this.mblDeviceTypeOnChange();
        }


        if (this.delimiterPrivacyvalue >= 100) {
          this.delimiterPrivacyvalue = 99.9;
        }

        this.privacyScoreStatus = response.data.privacyScoreStatus;
        if (this.privacyScore <= 250) {
          this.color = '#FF4B2B'
        } else if (this.privacyScore >= 251 && this.privacyScore <= 500) {
          this.color = '#FB6C6C'
        } else if (this.privacyScore >= 501 && this.privacyScore <= 800) {
          this.color = '#F59E0B'
        } else {
          this.color = '#1ECB1A'
        }
        if (this.privacyScore >= 50) {
          this.securityColor = 'rgb(58, 215, 55, 1)'
        } else {
          this.securityColor = 'rgb(255, 65, 65, 1)'
        }
        this.options1 = {
          hasNeedle: true,
          needleColor: '#023047',
          needleUpdateSpeed: 1000,
          arcColors: [this.color, 'lightgray'],
          arcDelimiters: [this.delimiterPrivacyvalue ? this.delimiterPrivacyvalue : 1],
          needleStartValue: 0.1,
        }
        if (this.privacyScore <= 250) {
          this.statusprivacyBg = "#FDDDDD";
          this.statusPrivacyClr = "#FF4B2B";
        } else if (this.privacyScore >= 251 && this.privacyScore <= 500) {
          this.statusprivacyBg = "#FFF0F0";
          this.statusPrivacyClr = "#FB6C6C";
        } else if (this.privacyScore >= 501 && this.privacyScore <= 800) {
          this.statusprivacyBg = "#FDECCE";
          this.statusPrivacyClr = "#F59E0B";
        } else {
          this.statusprivacyBg = "#D5FED6";
          this.statusPrivacyClr = "#1ECB1A";
        }
        this.delimitervalue = (response.data.securityScore / 10);
        if (this.delimitervalue >= 100) {
          this.delimitervalue = 99.9;
        }
        this.securityScoreStatus = response.data.securityScoreStatus;
        if (this.securityScore <= 250) {
          this.color = '#FF4B2B';
        } else if (this.securityScore >= 251 && this.securityScore <= 500) {
          this.color = '#FB6C6C';
        } else if (this.securityScore >= 501 && this.securityScore <= 800) {
          this.color = '#F59E0B';
        } else {
          this.color = '#1ECB1A';
        }
        if (this.securityScore >= 50) {
          this.securityColor = 'rgb(58, 215, 55, 1)';
        } else {
          this.securityColor = 'rgb(255, 65, 65, 1)';
        }
        this.options = {
          hasNeedle: true,
          needleColor: '#023047',
          needleUpdateSpeed: 1000,
          arcColors: [this.color, 'lightgray'],
          arcDelimiters: [this.delimitervalue ? this.delimitervalue : 1],
          needleStartValue: 0.1,
        }
        if (this.securityScore <= 250) {
          this.statusBg = "#FDDDDD";
          this.statusClr = "#FF4B2B";
        } else if (this.securityScore >= 251 && this.securityScore <= 500) {
          this.statusBg = "#FFF0F0";
          this.statusClr = "#FB6C6C";
        } else if (this.securityScore >= 501 && this.securityScore <= 800) {
          this.statusBg = "#FDECCE";
          this.statusClr = "#F59E0B";
        } else {
          this.statusBg = "#D5FED6";
          this.statusClr = "#1ECB1A";
        }


      }
    })
  }
  mblDeviceTypeOnChange() {
    if (this.screenWidth > 768) {
      if (this.privacy_score === 0 && this.security_score === 0) {
        this.margins = "145px auto";
      } else if ((this.privacy_score > 0 && this.privacy_score <= 800) && (this.security_score > 0 && this.security_score <= 800)) {
        this.margins = "145px auto"
      } else {
        this.margins = "145px auto"
      }
    }
  }
  //  Go To Commands Page
  gotoCommands(id: any, type: any) {
    if (type === 'TRACE') {
      this.router.navigateByUrl(`/home/locate-device/${id}`)
    } else if (type === 'SCAN_FROM_CLOUD') {
      this.router.navigateByUrl(`/home/scan-device/${id}`)
    } else if (type === 'ANTITHEFT_SETTINGS') {
      this.router.navigateByUrl(`/home/anti-theft-device/${id}`)
    } else if (type === 'WIPE') {
      this.router.navigateByUrl(`/home/wipe-device/${id}`)
    } else if (type === 'BLOCK') {
      this.router.navigateByUrl(`/home/lock-device/${id}`)
    }
    else if (type === 'UPDATE_VIRUS_DB') {
      this.router.navigateByUrl(`/home/update-virus-device/${id}`)
    }
    else if (type === 'SYNC_DEVICE') {
      this.router.navigateByUrl(`/home/sync-device/${id}`)
    } else if (type === 'RING_DEVICE') {
      this.router.navigateByUrl(`/home/ring-device/${id}`)
    }
    else if (type == 'SCORE') {
      this.router.navigateByUrl(`/home/sync-score/${id}`)
    }

  }

  getDeviceData(userId: any) {
    try {
      let url = userId && userId != null ? `${this._service.API_URL.getSystemMobileData}?userId=${encodeURIComponent(this.userId)}&timezone=${encodeURIComponent(this.userTimezone)}&selectedLang=${encodeURIComponent(this.selectedLanguage)}` : `${this._service.API_URL.getSystemMobileData}?timezone=${encodeURIComponent(this.userTimezone)}&selectedLang=${encodeURIComponent(this.selectedLanguage)}`;
      this._service.getService(url).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.showParentalTab = response.data.filter((data: any) => data.deviceType === 'MOBILE').length > 0;
          this.showAntiTrackerReports = response.data.filter((data: any) => data.deviceType === 'SYSTEM').length > 0;
        }
      })
    }
    catch (error) {
    }
  }

  getSystemMobileData() {
    let apiUrl: any;
    try {
      apiUrl = `${this._service.API_URL.getSystemMobileData}?timezone=${encodeURIComponent(this.userTimezone)}&selectedLang=${encodeURIComponent(this.selectedLanguage)}`;
      this._service.getService(apiUrl).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.devicesList = response.data;
          this.getDeviceId = this.devicesList[0]?.id;

          if (this.devicesList == null) {
            this.img_blr = true
          }
          if (this.getDeviceId) {
            this.devicesList.forEach(element => {
              this.deviceId = element?.id;
              if (this.getDeviceId == element?.id) {
                this.productKeyType = element?.deviceType;
                this.restorePublishForm.controls['mobileDeviceName'].setValue(element?.id);
                if (this.productKeyType == "SYSTEM") {
                  this.margins = '12px auto';
                } else {
                  this.mblDeviceType();
                }
              }
            });
          } else {
            this.restorePublishForm.controls['mobileDeviceName'].setValue(this.devicesList[0]?.id);
          }
        }
      })
    } catch (error) {
      console.log(error);
    }
  }
  mblDeviceType() {
    if (this.screenWidth > 768) {
      if (this.privacy_score === 0 && this.security_score === 0) {
        this.margins = "145px auto";
      } else if ((this.privacy_score > 0 && this.privacy_score <= 800) && (this.security_score > 0 && this.security_score <= 800)) {
        this.margins = "145px auto"
      } else {
        this.margins = "145px auto"
      }
    }
  }
  removeSpace(event: any) {
    if (event.code === "Space") {
      event.preventDefault()
    }
  }
  keyPressAlphaNumericWithCharacters(event: any) {
    let k;
    k = event.charCode;  //k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));

  }

  mobileNoWrong: boolean = false;
  onFocusOutMobile(event: any) {
    this.mobileNoWrong = event?.number?.length < 8;
  }

  //Verify Device Popup Form Data Submit - Deepa
  verifyDeviceDetail() {
    try {
      this.mobileNumber = this.deviceDetailForm.controls['userName'].value.number;
      let data = {
        "userName": this.deviceDetailForm.controls['userName'].value.number,
        "countryCode": this.deviceDetailForm.controls['userName'].value.dialCode,
        "otpType": CommonEnums.MOBILE_VERIFICATION,
      }
      this.sentMobileNo = this.deviceDetailForm.controls['userName'].value.number
      this._service.postService(this._service.API_URL.generateOTP, data).subscribe((response: any) => {
        if (response.status.code === 200) {
          if (response.status.msgCode == "MOBILE_VERIFICATION") {
            this.isMobile = false;
            this.isOTP = false;
            this.isDone = true;
          } else {
            this.emailResponse = response.data;
            this.isMobile = false;
            this.mobileOTPResponse = response.data;
            this.isOTP = true;
            this.timeOver = true;
            this.startTimerForFiveMinute(3);
          }
        }
        else {
          this.isOTP = false;
          this._toastr.error('', response.status.message)
        }
      })
    } catch (error) {

    }
  }

  //  Start timer for Email Verification, Forgot Password
  startTimerForFiveMinute(minute: number) {
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;
    const prefix = minute < 10 ? "0" : "";
    this.timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.durationMinutes = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      if (seconds == 0) {
        this.timeOver = false;
        clearInterval(this.timer);
      }
    }, 1000);
  }


  onOtpChange(event: any) {
    this.otpError = null;
    this.otpValue = event;
  }
  submitOTP() {
    try {
      if (this.otpValue?.length == 4) {
        this.otpDto.otpNo = this.otpValue;
        this.otpDto.otpType = CommonEnums.MOBILE_VERIFICATION;
        this.otpDto.otpChar = this.emailResponse;
        this._service.postService(this._service.API_URL.otpVerification, this.otpDto).subscribe((response: any) => {
          if (response && response.status.code === 200) {
            $("#verifyDetailsPopup").modal("show")
            this.isOTP = false;
            this.isDone = true;
          } else {
            this.otpError = response.status.message;
          }
        })
      }
    }
    catch (e) { }
  }
  closeModalForMobileNumber() {
    this.isMobile = true;
    this.isOTP = false;
    this.isDone = false;
    this.deviceDetailForm.reset();
    $("#verifyDetailsPopup").modal("hide")
  }
  resendOtp() {
    try {
      this.otpError = null;
      this.ngOtpInputRef.setValue(null);
      clearInterval(this.timer);
      this.isOTP = true;
      this.timeOver = true;
      this.isMobile = false;
      let vinit = this.sentMobileNo;
      let data = {
        "userName": vinit,
        "otpType": CommonEnums.MOBILE_VERIFICATION,
        "isResendOTP": true
      }

      this._service.postService(this._service.API_URL.generateOTP, data).subscribe((response: any) => {
        if (response && response.status.code === 200) {
          if (response.status.msgCode == "MOBILE_VERIFICATION") {
            this.isMobile = false;
            this.isOTP = false;
            this.isDone = true;
          } else {
            this.emailResponse = response.data;
            this.isMobile = false;
            this.isOTP = true;
            this.timeOver = true;
            this.startTimerForFiveMinute(3);
          }
        } else {
          this.otpError = response.status.message;
          this.timeOver = false;
        }
      })
    }
    catch (e) { }
  }

  closeVerifyDetails() {
    this.isMobile = false;
    this.isOTP = false;
    this.isDone = false;
    this.deviceDetailForm.reset();
    $("#verifyDetailsPopup").modal("hide");
    this.router.navigateByUrl('/home/add-device');
  }

  getAllUserLicense() {
    try {
      this.isLoading = true;
      this._service.getService(this._service.API_URL.getAllUserLicense).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;

          this.totalExpired = response?.data?.totalexpiredcount
          this.totalExpiringSoon = response?.data?.totalexpiringsooncount
          this.totallicenseFreeCount = response?.data?.totalfreecount
          this.isCarouselVisible = (this.totalExpired ?? 0) > 0 ||
            (this.totalExpiringSoon ?? 0) > 0 ||
            (this.totallicenseFreeCount ?? 0) > 0;
          this.dashboardMarkup = response?.data?.myLicenseList
          this.dashboardMarkup.forEach((resp: any) => {
            if (resp.licenseValidityDate != 'Free version') {
              let a = resp.licenseValidityDate.split("(");
              const date1: any = new Date(a[0]);
              const date2: any = new Date();
              const diffTime: any = Math.abs(date2 - date1);
              const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
              if (date2 < date1) {
                resp['aboutToExpire'] = Number(diffDays) <= 15;
              } else {
                resp['aboutToExpire'] = true;
              }
            }
          });
          let shownTabs: any[] = this.dashboardMarkup.filter((slide: any) => slide.licenseValidityDate == 'Free version' || (slide.licenseValidityDate.includes('Premium Validity') && slide.aboutToExpire))
          this.dashboardOptions.loop = shownTabs?.length > 1;

        } else {
          this.isLoading = false;
        }
      })
    } catch (error) {
      this.isLoading = false;
    }
  }
  getProductIcon(productType: string) {
    switch (productType) {
      case "MOBSEC_BASIC":
        //Using MAC's icon temporarily
        return this.enDataJson[0]['ICON_QHMS'];
      case "MOBSEC_ADVANCE":
        return this.enDataJson[0]['ICON_QHTSA'];
      case "QH_TS":
        return this.enDataJson[0]['ICON_QHTS'];
      case "QH_IS":
        return this.enDataJson[0]['ICON_QHIS'];
      case "QH_IS_ESSENTIAL":
        return this.enDataJson[0]['ICON_QHISE'];
      case "QH_MULTI_DEVICE_TOTAL":
        return this.enDataJson[0]['ICON_QHTSMD'];
      case "QH_AV":
        return this.enDataJson[0]['ICON_QHAVPRO'];
      default:
        return this.enDataJson[0]['ICON_QHTS'];
    }
  }
  getAllUser() {
    this.isLoading = true;
    try {
      this._service.getService(this._service.API_URL.getMyUsers).subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.userResponse = response.data;
          this.getScoreManagement(response.data[0], this.selectedIndex)
        } else {
          this.isLoading = false;
          this._toastr.error('', response.status.message);
        }
      })
    } catch (error) {
      this.isLoading = false;
    }
  }

  getMyUser() {
    try {
      this.isLoading = true;
      this._service.getService(this._service.API_URL.getMyUsers).subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.currentUserData = response.data[0]
          this.isLoading = false;
          this.userResponse = response.data.filter((userdevicecount: { deviceCount: number; }) => userdevicecount.deviceCount != 0);
          if (this.userResponse?.length != 0) {
            this.getdashboardDataByuserId(this.userResponse[0].id);
            this.user = this.userResponse[0].id;
          } else {
            this.getdashboardDataByuserId(response.data[0].id);
          }
        }
      });
    } catch (error) { }
  }


  getScoreManagement(data: any, index: any) {
    this.userId = data.id
    this.isLoading = true;
    this.selectedIndex = index;
    try {
      this._service.getService(this._service.API_URL.getScoreManagement + "?userId=" + data.id).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.ScoreManagementData = response.data;
          this.deviceId = this.ScoreManagementData[0].deviceOrSystemId;
          this.privacyScore = response.data[0].privacyScore;
          this.securityScore = response.data[0].securityScore;
        } else {
          this.isLoading = false;
          this._toastr.error('', response.status.message);
        }
      })
    } catch (error) {
      this.isLoading = false;
    }
  }

  syncScoreArr: any = []
  openSyncScoreModal(id: any, type: any) {
    this.syncScoreArr = [];
    this.syncScoreArr.push(id, type);
    this.sendCommandScore(id, type);
  }
  selectReport(reportType: any) {
    this.selectedReport = reportType;
  }

  // lastUpdatedDate: any;
  // chartsStrings: any;
  areaNoOfCategories: any;
  isApp: boolean = false;
  norecordsAppUsage: boolean = false;
  timeInhours: string;

  //  Fetching the data for the line graph and displaying the same
  noOfItemToShow: any;
  norecordsThreatWebUsage: boolean = false;
  getWebAppLineGraphData(deviceId: any) {
    let graph = this.isApp;
    this.isLoading = true;
    this._service.getService(this._service.API_URL.getWebAppLineGraphData + deviceId + '?isApp=' + graph + "&width=" + this.screenWidth + "&height=" + this.screenHeight).subscribe((response) => {
      if (response && response.status.code === 200) {
        this.lastUpdatedDate = response.data.lastUpdatedDate;
        this.data = response.data;
        this.isLoading = false;
        this.noOfItemToShow = response.data.noOfItemToShow;
        if (response.data.graphList && response.data.graphList?.length != 0) {
          this.norecordsAppUsage = false
        } else {
          this.norecordsAppUsage = true
        }

        if (this.data.graphList?.length != 0 && this.data.graphList) {
          setTimeout(() => {
            let chartExist = Chart.getChart("AppUsageChart"); // <canvas> id
            if (chartExist != undefined) {
              chartExist.destroy();
            }
            let datalabels = response['data'].graphList.map((res: any) => res.category);
            let dataValue = response['data'].graphList.map((res: any) => res.appUsageDuration);
            const titleTooltip = (tooltipItems: any) => {
              return '';
            }
            const gradient = this.barChartGraph.nativeElement.getContext('2d').createLinearGradient(0, 0, 0, 600);
            gradient.addColorStop(0, '#D0E2EA');
            gradient.addColorStop(0.5, '#EEF4F7');
            this.chart = new Chart("AppUsageChart", {
              type: "bar",
              data: {
                labels: datalabels,
                datasets: [
                  {
                    data: dataValue,
                    maxBarThickness: window.screen.width > 768 ? 60 : window.screen.width < 768 && window.screen.width > 480 ? 30 : 20,
                    borderColor: '#136B97',
                    borderRadius: {
                      topLeft: 10,
                      topRight: 10,
                    },
                    barPercentage: 0.5,
                    hoverBackgroundColor: '#136B97',
                    backgroundColor: gradient,
                    hoverBorderColor: '#9ecfdb',
                    borderWidth: 1,
                    borderSkipped: false,
                  }
                ],
              },
              options: {
                maintainAspectRatio: false,
                plugins: {
                  legend: {
                    display: false
                  },
                  tooltip: {
                    yAlign: 'bottom',
                    displayColors: false,
                    padding: {
                      right: 15,
                      left: 15,
                      top: 10,
                      bottom: 10
                    },
                  },
                  datalabels: {
                    anchor: 'end',
                    align: 'end',
                    display: false
                  }
                },
                responsive: true,
                scales: {
                  x: {
                    grid: {
                      color: '#E7E6E6',
                      borderDash: [5, 5],
                    },
                    ticks: {
                      callback: function (value: any) {
                        return (datalabels[value]?.length > 10 && window.screen.width >= 768) ? (datalabels[value].substring(0, 10) + '...') : (datalabels[value]?.length > 2 && window.screen.width < 768) ? (datalabels[value].substring(0, 2) + '...') : datalabels[value];
                      },
                      autoSkip: false,
                      maxRotation: 0,
                      minRotation: 0,
                    }
                  },
                  y: {
                    grid: {
                      color: '#E7E6E6',
                      borderDash: [5, 5]
                    },
                    title: {
                      display: true,
                      text: this.timeInhours,
                      font: {
                        family: 'open sans',
                        size: 14,
                      }
                    },
                  },
                },
              },
            });
          }, 500);
        }
      }
      this.isLoading = false;
    })
  }


  deviceNameData: any;
  imagesList: any;
  images = [
    { url: './assets/images/deviceNameimage1.svg' },
    { url: './assets/images/deviceNameimage2.svg' },
    { url: '/assets/images/deviceNameimage3.svg' },
    { url: '/assets/images/deviceNameimage4.svg' },
    { url: '/assets/images/deviceNameimage5.svg' },
    { url: '/assets/images/deviceNameimage6.svg' },
    { url: '/assets/images/deviceNameimage7.svg' },
    { url: '/assets/images/deviceNameimage8.svg' },
    { url: '/assets/images/deviceNameimage9.png' },
    { url: '/assets/images/deviceNameimage10.svg' },

  ];
  item: { key: unknown } = { key: 'string' };
  isString(value: unknown): value is string {
    return typeof value === 'string';
  }
  areaChart(userId: any) {
    this.isLoading = true;
    this._service.getService(this._service.API_URL.threatReportsDevices + this.userId + "?width=" + this.screenWidth + "&height=" + this.screenHeight + '&deviceType=' + 'MOBILE').subscribe((response) => {
      if (response && response.status.code === 200) {
        this.lastUpdatedDate = response.data.lastUpdatedDate;
        this.data = response.data;
        this.areaNoOfCategories = response.data.noOfItemToShow;
        this.isLoading = false;
        let countsList2: any[] = [];
        let totalcountsnew: any[] = [];
        response.data.graphList.forEach((item: { youtubeTableDtoList: any[]; }) => {
          countsList2.push(item.youtubeTableDtoList);
        });
        this.noOfItemToShowThreat = countsList2.filter((countsList2) => countsList2.length != 0);
        this.threatsdetected = this.noOfItemToShowThreat.length;
        this.threatDeviceCount = this.noOfItemToShowThreat;
        let devicenameset = new Set()
        let deviceNameList = this.threatDeviceCount.flatMap(subArray => subArray.map((obj: { deviceName: any; }) => devicenameset.add(obj.deviceName)));
        this.threatDeviceCount.map(i => i.deviceName);
        deviceNameList.filter(i => i.deviceName && i.deviceName !== i.deviceName);
        this.deviceNameData = Array.from(devicenameset);
        this.devicenamelength = this.deviceNameData.length;
        this.imagesList = this.images;
        this.deviceNameListMap = new Map();
        // Populate the Map using the two lists
        this.deviceNameData.forEach((key: any, index: string | number) => {
          const value = this.imagesList[index];
          this.deviceNameListMap.set(key, value.url);
        });
        setTimeout(() => {
          this.totalCount = 0;

        }, 300);
        setTimeout(() => {
          let chartExist = Chart.getChart("threatReportChart"); // <canvas> id
          if (chartExist != undefined) {
            chartExist.destroy();
          }
          response.data.graphList.forEach((graph: { youtubeTableDtoList: any[]; }) => {
            let totalcounts: string[] = [];
            graph.youtubeTableDtoList.forEach(item => {
              totalcounts.push(item.count);
            });
            totalcountsnew.push(totalcounts);

          });

          let countsList: string[] = [];
          response.data.graphList.forEach((graph: { youtubeTableDtoList: any[]; }) => {
            graph.youtubeTableDtoList.forEach(item => {
              countsList.push(item.count);
            });
          });

          countsList.forEach((element: any) => {
            this.totalCount = this.totalCount + element;
          });
          let datalabels = response.data.graphList[0].youtubeTableDtoList?.map((res: any) => res.date);
          const titleTooltip = (tooltipItems: any) => {
            return ''
          }
          const canvas = document.getElementById('threatReportChart');
          const ctx = (canvas as HTMLCanvasElement)?.getContext('2d');
          let areaGradient = ctx?.createLinearGradient(0, 0, 0, 600);
          areaGradient?.addColorStop(0, '#D0E2EA');
          areaGradient?.addColorStop(0.5, '#EEF4F7');
          this.chart = new Chart("threatReportChart", {
            type: "line",
            data: {

              labels: datalabels,
              datasets: [{
                data: totalcountsnew[0],
                borderColor: "#FF3C33",
                backgroundColor: '#ffff',
                cubicInterpolationMode: 'monotone',
                tension: 0.001,
                fill: false,
                pointStyle: 'dot',
                pointBackgroundColor: '#FF3C33',
                pointHoverBackgroundColor: '#FF3C33',
                pointRadius: 5,
              },
              {
                data: totalcountsnew[1],
                borderColor: "#0D79FF",
                backgroundColor: '#ffff',
                cubicInterpolationMode: 'monotone',
                tension: 0.001,
                fill: false,
                pointStyle: 'dot',
                pointBackgroundColor: '#0D79FF',
                pointHoverBackgroundColor: '#0D79FF',
                pointRadius: 5,
              },
              {
                data: totalcountsnew[2],
                borderColor: "#FF950D",
                backgroundColor: '#ffff',
                cubicInterpolationMode: 'monotone',
                tension: 0.001,
                fill: false,
                pointStyle: 'dot',
                pointBackgroundColor: '#FF950D',
                pointHoverBackgroundColor: '#FF3C0D79FF33',
                pointRadius: 5,
              },
              {
                data: totalcountsnew[3],
                borderColor: "#D35FD7",
                backgroundColor: '#ffff',
                cubicInterpolationMode: 'monotone',
                tension: 0.001,
                fill: false,
                pointStyle: 'dot',
                pointBackgroundColor: '#D35FD7',
                pointHoverBackgroundColor: '#FF3C0D79FF33',
                pointRadius: 5,
              },
              {
                data: totalcountsnew[4],
                borderColor: "#38B2C5",
                backgroundColor: '#ffff',
                cubicInterpolationMode: 'monotone',
                tension: 0.001,
                fill: false,
                pointStyle: 'dot',
                pointBackgroundColor: '#38B2C5',
                pointHoverBackgroundColor: '#FF3C0D79FF33',
                pointRadius: 5,
              },
              {
                data: totalcountsnew[5],
                borderColor: "#7CB342",
                backgroundColor: '#ffff',
                cubicInterpolationMode: 'monotone',
                tension: 0.001,
                fill: false,
                pointStyle: 'dot',
                pointBackgroundColor: '#7CB342',
                pointHoverBackgroundColor: '#FF3C0D79FF33',
                pointRadius: 5,
              },
              {
                data: totalcountsnew[6],
                borderColor: "#039BE5",
                backgroundColor: '#ffff',
                cubicInterpolationMode: 'monotone',
                tension: 0.001,
                fill: false,
                pointStyle: 'dot',
                pointBackgroundColor: '#039BE5',
                pointHoverBackgroundColor: '#FF3C0D79FF33',
                pointRadius: 5,
              },
              {
                data: totalcountsnew[7],
                borderColor: "#673AB7",
                backgroundColor: '#ffff',
                cubicInterpolationMode: 'monotone',
                tension: 0.001,
                fill: false,
                pointStyle: 'dot',
                pointBackgroundColor: '#673AB7',
                pointHoverBackgroundColor: '#FF3C0D79FF33',
                pointRadius: 5,
              },
              {
                data: totalcountsnew[8],
                borderColor: "#546E7A",
                backgroundColor: '#ffff',
                cubicInterpolationMode: 'monotone',
                tension: 0.001,
                fill: false,
                pointStyle: 'dot',
                pointBackgroundColor: '#546E7A',
                pointHoverBackgroundColor: '#FF3C0D79FF33',
                pointRadius: 5,
              },
              {
                data: totalcountsnew[9],
                borderColor: "#FFF176",
                backgroundColor: '#ffff',
                cubicInterpolationMode: 'monotone',
                tension: 0.001,
                fill: false,
                pointStyle: 'dot',
                pointBackgroundColor: '#FFF176',
                pointHoverBackgroundColor: '#FF3C0D79FF33',
                pointRadius: 5,
              },
              {
                data: totalcountsnew[10],
                borderColor: "#FFF176",
                backgroundColor: '#ffff',
                cubicInterpolationMode: 'monotone',
                tension: 0.001,
                fill: false,
                pointStyle: 'dot',
                pointBackgroundColor: '#FFF176',
                pointHoverBackgroundColor: '#FF3C0D79FF33',
                pointRadius: 5,
              },

              ]
            },
            options: {
              plugins: {
                datalabels: {

                  display: false,
                },
                legend: {
                  display: false
                },
                tooltip: {
                  enabled: true,
                  backgroundColor: "#023047",
                  titleColor: "#FFFFFF",
                  bodyColor: "#FFFFFF",
                  titleFont: { weight: 'bold' },
                  padding: 9,
                  cornerRadius: 3,
                  position: 'nearest',
                  borderColor: "#042a0b",
                  borderWidth: 1,
                  usePointStyle: true,
                  xAlign: left,
                  callbacks: {
                    title: () => {
                      return '';
                    }
                  }
                },
                title: {
                  display: true,
                },
              },
              scales: {
                y: {
                  suggestedMin: 0,
                  suggestedMax: 6,
                  grid: {
                    color: '#E7E6E6',
                    borderDash: [5, 0]
                  },
                  title: {
                    display: true,
                    text: this.deviceType == 'MOBILE' ? this.chartsStrings['THREATCOUNT'] : this.chartsStrings['THREATSDETECTED'],
                    font: {
                      family: 'open sans',
                      size: 12,
                    }
                  },
                  ticks: {
                    precision: 0
                  }
                },
                x: {
                  grid: {
                    display: false,
                    color: '#E7E6E6',
                    borderDash: [0, 5]
                  },
                  title: {
                    display: true,
                    text: this.chartsStrings['DAYS'],
                    font: {
                      family: 'open sans',
                      size: 14,
                    }
                  },
                  ticks: {
                    callback: function (value: any) {
                      if (datalabels[value]?.length > 10) {
                        return datalabels[value].substr(0, 10) + '...';
                      }
                      else {
                        return datalabels[value]
                      }
                    }
                    ,
                    autoSkip: false,
                    maxRotation: 0,
                    minRotation: 0,
                  }
                },
              },
              responsive: true,
              maintainAspectRatio: false,
            }
          });

        }, 500);
        //}
      } else {
        this.isLoading = false;
      }
    })
  }

  totalCount: number = 0;
  alldevicescount: number = 0;
  countText: any;
  donughtChart(deviceId: any) {
    this.isLoading = true;
    this._service.getService(this._service.API_URL.threatDonutReport + this.getDeviceId + '?deviceType=' + 'MOBILE').subscribe((response) => {
      if (response && response.status.code === 200) {
        setTimeout(() => {
        }, 450);
        this.data = response.data;
        this.isLoading = false;
        this.noOfItemToShow = response.data.noOfItemToShow;
        setTimeout(() => {
          if (response.data?.length != 0) {
            this.norecordsThreatWebUsage = false;
          } else {
            this.norecordsThreatWebUsage = true;
          }

        }, 300);
        let datalabels = response['data']?.map((res: any) => res.key);
        const dataValue = response['data']?.map((res: any) => Math.round(res.percentage));
        for (let i = 0; i < dataValue?.length; i++) {
          if (dataValue[i] == 0 || dataValue[i] == 0.00) {
            dataValue.splice(dataValue.indexOf(dataValue[i]), 1);
            datalabels.splice(dataValue.indexOf(dataValue[i]), 1);
            i = i - 1
          }
        }
        let substringLimit = 10;
        const labelsData = datalabels;

        if (this.data?.length != 0) {
          setTimeout(() => {
            let chartExist = Chart.getChart("myChartWebUsage"); // <canvas> id
            if (chartExist != undefined) {
              chartExist.destroy();
            }


            let hovering = false;
            let tooltip = document.getElementById("threatWebUsagetooltip"), tooltips = datalabels;
            const canvas = document.getElementById('myChartWebUsage');
            const ctx = (canvas as HTMLCanvasElement)?.getContext('2d');
            const gradient = ctx?.createLinearGradient(0, 0, 0, 600);
            let purpleGradient = ctx?.createLinearGradient(0, 0, 0, 450);
            let yellowGradient = ctx?.createLinearGradient(0, 0, 0, 450);
            let pinkGradient = ctx?.createLinearGradient(0, 0, 0, 450);
            let blueGradient = ctx?.createLinearGradient(0, 0, 0, 450);
            let redGradient = ctx?.createLinearGradient(0, 0, 0, 450);
            let greyGradient = ctx?.createLinearGradient(0, 0, 0, 450);
            purpleGradient?.addColorStop(0, 'rgba(112, 161, 255, 1)');
            purpleGradient?.addColorStop(1, 'rgba(242, 247, 255, 1)');
            yellowGradient?.addColorStop(0, 'rgba(255, 189, 19, 1)');
            yellowGradient?.addColorStop(1, 'rgba(255, 213, 106, 0.8)');
            pinkGradient?.addColorStop(0, 'rgba(250, 51, 255, 1)');
            pinkGradient?.addColorStop(1, 'rgba(253, 175, 255, 0.8)');
            blueGradient?.addColorStop(0, 'rgba(80, 51, 255, 1)');
            blueGradient?.addColorStop(1, 'rgba(80, 51, 255, 0.6)');
            redGradient?.addColorStop(0, 'rgba(255, 94, 94, 1)');
            redGradient?.addColorStop(1, 'rgba(255, 255, 255, 0)');
            greyGradient?.addColorStop(0, 'rgba(209, 209, 209, 1)');
            greyGradient?.addColorStop(1, 'rgba(255, 255, 255, 0.8)')

            let chartColors = [
              'rgba(112, 161, 255, 0.8)rgba(242,247,255,0)',
              'rgba(255, 200, 58, 0.8)rgba(255,222,137,0)',
              'rgba(250,51,255,0.8)rgba(253,175,255,0)',
              'rgba(80,51,255,0.8)rgba(80,51,255,0)',
              'rgba(255, 64, 64, 0.8)rgba(255,255,255,0)',
              'rgba(209,209,209,0.8)rgba(255,255,255,0)',
            ];
            this.chart = new Chart("myChartWebUsage", {

              type: "doughnut",
              data: {
                labels: datalabels,
                datasets: [
                  {
                    backgroundColor: [purpleGradient, yellowGradient, pinkGradient, blueGradient, redGradient, greyGradient],
                    borderColor: ['rgba(55, 123, 255, 1)', 'rgba(255, 190, 26, 1)', 'rgba(250, 51, 255, 1)', 'rgba(80, 51, 255, 1)', 'rgba(255, 64, 64, 1)', 'rgba(170,164, 164, 1)'],
                    hoverBackgroundColor: chartColors,
                    hoverBorderColor: ['rgba(55, 123, 255, 1)', 'rgba(255, 190, 26, 1)', 'rgba(250, 51, 255, 1)', 'rgba(80, 51, 255, 1)', 'rgba(255, 64, 64, 1)', 'rgba(170,164, 164, 1)'],
                    hoverBorderWidth: 2,
                    borderWidth: 1,
                    data: dataValue,
                    hoverOffset: 1
                  }
                ],
              },
              options: {
                responsive: true,
                maintainAspectRatio: false,
                cutout: '60%',

                plugins: {
                  legend: {
                    display: true,
                    position: 'right',
                    maxWidth: 130,
                    onHover: this.deviceType == 'SYSTEM' ? function (event: any, legendItem: any) { hovering = false; } : function (event: any, legendItem: any) {
                      if (hovering) {
                        return datalabels[legendItem['index']];
                      }
                      hovering = true;
                      if (tooltip != null) {
                        tooltip.innerHTML = tooltips[legendItem['index']];
                        tooltip.style.left = 86 + "%";
                        tooltip.style.top = event.y - 40 + "px";
                        tooltip.style.padding = "3.5px";
                        tooltip.style.minWidth = "fit-content";
                        tooltip.style.whiteSpace = "nowrap";
                      }
                    },
                    onLeave: function () {
                      hovering = false;
                      if (tooltip != null) {
                        tooltip.style.padding = "0px"
                        tooltip.innerHTML = "";
                      }
                    },
                    labels: {
                      generateLabels: (chart: any) => {
                        return chart.data.labels.map((l: any, i: any) => ({
                          datasetIndex: 0,
                          index: i,
                          text: l?.length > substringLimit ? l.substring(0, substringLimit) + '...' : l,
                          fillStyle: chart.data.datasets[0].backgroundColor[i],
                          strokeStyle: chart.data.datasets[0].hoverBorderColor[i],
                          hiddens: !chart.getDatasetMeta(0).data[i].hidden
                        }));
                      },

                      padding: 18,
                      usePointStyle: true,
                      font: {
                        size: window.screen.width > 700 && window.screen.width < 800 ? 14 : window.screen.width < 1366 ? 10 : 12
                      }
                    },
                    onClick(e: any, legendItem: any, legend: any) {
                      const index = legendItem.index;
                      const currentLabels = this.chart.data.labels;
                      let newLabels: any[] = []
                      if (currentLabels) {
                        for (let i = 0; i < currentLabels?.length; i++) {
                          if (i == index) {
                            if (labelsData[i] == currentLabels[i]) {
                              newLabels?.push(String(currentLabels[i]).split('').map((char: any) => char + '\u0336').join(''))
                              legend.chart.getDatasetMeta(0).data[i].hidden = true
                              legend.chart.getDatasetMeta(0).data[i].visible = 0
                              substringLimit = 15;
                            } else {
                              newLabels.push(String(labelsData[i]))
                              legend.chart.getDatasetMeta(0).data[i].hidden = false
                              legend.chart.getDatasetMeta(0).data[i].visible = 1;
                            }
                          } else {
                            newLabels.push(String(currentLabels[i]))
                          }
                        }
                      }
                      // Update the label at the clicked index
                      this.chart.data.labels = newLabels;
                      this.chart.update();
                    },
                  },
                  tooltip: {
                    enabled: true,
                    callbacks: {
                      label: (tooltipItem) => {
                        let lbl = tooltipItem['label'] + ' : ' + this.countText[tooltipItem['dataIndex']]
                        return lbl;
                      }
                    }
                  },
                  datalabels: {
                    display: true,
                    formatter: function (value, context: any) {
                      let hiddens = context.chart._hiddenIndices;
                      let total = 0;
                      let datapoints = context.dataset.data;
                      datapoints.forEach((val: any, i: any) => {
                        if (hiddens[i] != undefined) {
                          if (!hiddens[i]) {
                            total += val;
                          }
                        } else {
                          total += val;
                        }
                      });
                      let percentage = (value / total * 100).toFixed(0) + '%';
                      let out = context.chart.data.labels[context.dataIndex] == datalabels[context.dataIndex] ? percentage : '';
                      return out;
                    },

                    labels: {
                      value: {
                        color: "black",
                        font: {
                          size: window.screen.width > 700 && window.screen.width < 800 ? 14 : window.screen.width < 1366 ? 10 : 12
                        },
                      },
                    }
                  }
                }
              }
            });
          }, 500);
        }
      } else {
        this.isLoading = false;
      }
    })
    // return;
  }



  sendCommandScore(id: any, type: any) {
    this.isLoading = true;
    try {
      this.sendCommanddto.deviceId = id;
      this.sendCommanddto.requestType = type;
      this.sendCommanddto.mobileNo = this.mobileNumber;
      this.sendCommanddto.productKeyType = this.productKeyType;
      this._service.postService(this._service.API_URL.sendCommand, this.sendCommanddto).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this._toastr.success(response.status.message);
        } else {
          this.isLoading = false;
          this._toastr.error('', response.status.message);
        }
      })
    } catch (error) {
      this.isLoading = false;
    }
  }
  goToLink(url: string) {
    window.open(url, '_blank');
  }
  goToPurchaseUrl(url: string, crwDomainUrl: string) {
    const newTab = window.open(url, '_blank');

    const messageHandler = (event: MessageEvent) => {
      if (event.origin !== crwDomainUrl) return;

      if (event.data === 'payment_success') {
        window.removeEventListener('message', messageHandler);
        this.handlePaymentSuccess();
      } else {
        window.removeEventListener('message', messageHandler);
        this.handlePaymentFailed();
      }
    };

    window.addEventListener('message', messageHandler);

  }



  handlePaymentSuccess(): void {
    this.isPaymentDone = true;
    this.modalRef?.close();
    //alert('Payment successful!');
    // Update license list or redirect
  }

  handlePaymentFailed(): void {
    this.modalRef?.close();
    //alert('Payment Failed!');
    // Update license list or redirect
  }

  checkBeforeRenew(purchaseLink: string, type: string, crwDomainUrl: string) {
    if (type === "MOBSEC_ADVANCE") {
      $('#renewPopup').modal('show');
    } else {
      this.goToPurchaseUrl(purchaseLink, crwDomainUrl);
    }
  }

  getUserWiseAntiTrackerReport(userId: any) {
    this.isLoading = true;
    this._service.getService(this._service.API_URL.getUserWiseAntiTrackerReport + userId).subscribe((response) => {
      if (response && response.data && response.status.code === 200) {
        this.data = response.data;
        this.isLoading = false;
        this.noOfDevices = response.data?.desktopAntiTrackerDtoList?.length;
        this.setAxisForAntiTrackerGraph(this.noOfDevices);
        if (this.noOfDevices != 0) {
          setTimeout(() => {
            let chartExist = Chart.getChart("dashboardAntiTrackerReport"); // <canvas> id
            if (chartExist != undefined) {
              chartExist.destroy();
            }
            let datalabels = response['data'].desktopAntiTrackerDtoList?.map((res: any) => res.systemName);
            let dataValue = response['data'].desktopAntiTrackerDtoList?.map((res: any) => res.count);
            let datalabelUsed: any = "Trackers Blocked";
            this.antiTrackersBlockedCnt = response['data'].totalCnt;
            let tick1 = {
              autoSkip: false,
              maxRotation: 0,
              minRotation: 0,
              callback: function (val: any, index: string | number,) {
                return datalabels[index].length > 7 ? datalabels[index].slice(0, 7) + "..." : datalabels[index];
              },
            }
            let tick2 = {
              autoSkip: false,
              maxRotation: 0,
              minRotation: 0,
              precision: 0,
              callback: function (value: any) {
                return `${value}`;
              }
            }
            let tickx;
            let ticky;
            if (this.noOfDevices > 3) {
              tickx = tick1;
              ticky = tick2;
            }
            else {
              tickx = tick2;
              ticky = tick1;
            }
            this.chart = new Chart("dashboardAntiTrackerReport", {
              type: "bar",
              data: {
                labels: datalabels,
                datasets: [
                  {
                    data: dataValue,
                    label: datalabelUsed,
                    maxBarThickness: window.screen.width > 768 ? 60 : 40,
                    borderColor: '#FF3C33',
                    borderRadius: {
                      topLeft: 10,
                      topRight: 10,
                      bottomRight: 10,
                    },
                    barPercentage: 0.8,
                    categoryPercentage: 0.4,
                    hoverBackgroundColor: '#FF3C33',
                    backgroundColor: '#FF3C33',
                    hoverBorderColor: '#FF3C33',
                    borderWidth: 0,
                    barThickness: 10,
                  }
                ],
              },
              options: {
                maintainAspectRatio: false,
                indexAxis: this.antiTrackerChartAxis,
                plugins: {
                  legend: {
                    display: false,
                    position: "top",
                    align: "end",
                  },
                  tooltip: {
                    displayColors: false,
                    backgroundColor: '#023047',
                    bodyColor: '#FFFFFF',
                    titleColor: '#FFFFFF',
                    borderColor: '#023047',
                    borderWidth: 1,
                    padding: {
                      right: 15,
                      left: 15,
                      top: 10,
                      bottom: 10
                    },
                  },
                  datalabels: {
                    anchor: 'end',
                    align: 'end',
                    display: false
                  }
                },
                responsive: true,
                scales: {
                  x: {
                    stacked: true,
                    grid: {
                      display: this.verticalGrid,
                      color: '#F1F1F1',
                      borderDash: [0, 0],
                      drawTicks: false,
                    },
                    title: {
                      display: true,
                      text: this.antiTracker_X_lable,
                      font: {
                        family: 'open sans',
                        size: 14,
                      }
                    },
                    ticks: tickx,
                  },
                  y: {
                    stacked: true,
                    grid: {
                      display: this.horizontalGrid,
                      color: '#F1F1F1',
                      borderDash: [0, 0],
                      drawTicks: false,
                    },
                    title: {
                      display: true,
                      text: this.antiTracker_Y_lable,
                      font: {
                        family: 'open sans',
                        size: 14,
                      }
                    },
                    ticks: ticky,
                  },
                },
              },
            });
          }, 500);
        }
      }
    })
  }


  getclick(data: any) {
    if (data == 'ANNOUNCEMENT') {
      this.getCampaignData(this.userId);
      this.getMyAnnounce === this.announcementArray
      this.isAnnouncemnt = true;
      this.isOffer = false;
      this.isblog = false;
      this.issurvey = false;
      this.top3 = false;

    }
    if (data == 'OFFER') {
      this.getCampaignData(this.userId);

      this.getMyOffer === this.offerArray
      this.isOffer = true;
      this.isAnnouncemnt = false;
      this.isblog = false;
      this.issurvey = false;
      this.top3 = false;

    }
    else if (data == 'BLOG') {
      this.getCampaignData(this.userId);
      this.getMyBlog === this.blogStore;
      this.isblog = true;
      this.isAnnouncemnt = false;
      this.isOffer = false;
      this.issurvey = false;
      this.top3 = false;

    }
    else if (data == 'SURVEY') {
      this.getCampaignData(this.userId);
      this.getMySurvey === this.surveyArray;
      this.issurvey = true;
      this.isAnnouncemnt = false;
      this.isOffer = false;
      this.isblog = false;
      this.top3 = false;
    }
    else if (data == 'ALL') {
      this.getCampaignDatalatest(this.userId);
      this.getAllCampaignsData = this.topcamp;
      this.top3 = true;
      this.issurvey = false;
      this.isAnnouncemnt = false;
      this.isOffer = false;
      this.isblog = false;
    }
    else if (!this.top3 && !this.issurvey && !this.isAnnouncemnt && !this.isOffer && !this.isblog) {
      this.top3 = true;
    }
  }

  isExpanded: boolean = true;
  toggleReadMore() {
    this.isExpanded = !this.isExpanded;
  }

  isExpandedblog: boolean = true;
  toggleReadMoreblog() {
    this.isExpandedblog = !this.isExpandedblog;
  }

  isExpandedoffer: boolean = true;
  toggleReadMoreoffer() {
    this.isExpandedoffer = !this.isExpandedoffer;
  }

  isExpandedsurvey: boolean = true;
  toggleReadMoreSurvey() {
    this.isExpandedsurevy = !this.isExpandedsurevy;
  }

  selectNotificationType(type: String) {
    this.selectedNotType = type;
  }

  viewMore() {
    this.router.navigateByUrl('/home/notification-view-more');
  }

}
